/* Czech texts, keyed by the English source text (see i18n.ts). */
export const CS: Record<string, string> = {
  'Picked {c}.':
    'Vybrána barva {c}.',
  'Picked {c} (not in the palette – add it with “From drawing”).':
    'Vybrána barva {c} (není v paletě – přidejte ji tlačítkem „Z kresby“).',
  'No painted area under the cursor.':
    'Pod kurzorem není žádná vybarvená plocha.',
  'My palette':
    'Moje paleta',
  'Could not read this file as SVG.':
    'Tento soubor nelze načíst jako SVG.',
  'From file':
    'Ze souboru',
  'The file’s colors were added as the palette “{name}”.':
    'Barvy ze souboru byly přidány jako paleta „{name}“.',
  'Discard unsaved changes to the current drawing?\n(A copy is kept in History.)':
    'Zahodit neuložené změny v aktuální kresbě?\n(Kopie zůstane v Historii.)',
  'Before opening {name}':
    'Před otevřením {name}',
  'Opened {name}':
    'Otevřeno: {name}',
  'Saved {name}':
    'Uloženo: {name}',
  'File name:':
    'Název souboru:',
  'PNG width in pixels:':
    'Šířka PNG v pixelech:',
  'Invalid width.':
    'Neplatná šířka.',
  'PNG export failed.':
    'Export do PNG se nezdařil.',
  'Before starting a new drawing':
    'Před založením nové kresby',
  'Applied the grout color and width to {n} {n|line|lines}.':
    'Barva a šířka spár byla použita na {n} {n|čáru|čáry|čar}.',
  'Autosave failed – remember to save your file.':
    'Automatické ukládání selhalo – nezapomeňte soubor uložit.',
  'Autosave':
    'Automatické uložení',
  'Before restoring an older version':
    'Před obnovením starší verze',
  'Restored the version from {time}':
    'Obnovena verze z {time}',
  'Symmetry center set.':
    'Střed symetrie je nastaven.',
  'Snapping on':
    'Přichytávání zapnuto',
  'Snapping off':
    'Přichytávání vypnuto',
  'The clipboard has no color codes.':
    'Ve schránce nejsou žádné kódy barev.',
  '{n} {n|area|areas}':
    '{n} {n|plocha|plochy|ploch}',
  'fill':
    'výplň',
  'stroke':
    'obrys',
  'No color – the bucket erases with it':
    'Bez barvy – kbelík s ní maže',
  'Recolored {n} {n|element|elements}.':
    'Přebarveno: {n} {n|prvek|prvky|prvků}.',
  'Click on the canvas to place the symmetry center.':
    'Klikněte na plátno a umístěte střed symetrie.',
  'Photo unlocked: drag it with the Select tool (where there are no shapes).':
    'Fotka je odemčená: přetáhněte ji nástrojem Výběr (tam, kde nejsou tvary).',
  'Remove the tracing photo?':
    'Odstranit fotku k obkreslení?',
  'Invalid page size.':
    'Neplatná velikost stránky.',
  '1 drawing unit = 1 {unit}. Set the page size to the real size of your mosaic.':
    '1 jednotka kresby = 1 {unit}. Nastavte velikost stránky na skutečnou velikost mozaiky.',
  'Could not read that image.':
    'Obrázek nelze načíst.',
  'Photo loaded and locked. Unlock it to move it with the Select tool.':
    'Fotka je načtená a zamčená. Odemkněte ji, chcete-li ji posunout nástrojem Výběr.',
  'Replace the photo to trace with the pasted image?':
    'Nahradit fotku k obkreslení vloženým obrázkem?',
  'The pasted image is now the photo to trace – “Make a mosaic from the photo” turns it into tiles.':
    'Vložený obrázek je teď fotkou k obkreslení – „Vytvořit mozaiku z fotky“ z něj udělá dlaždice.',
  'Replace photo…':
    'Nahradit fotku…',
  'Load photo…':
    'Načíst fotku…',
  'Close shape':
    'Uzavřít tvar',
  'Done':
    'Hotovo',
  'Start the cut inside a closed area.':
    'Řez začněte uvnitř uzavřené plochy.',
  'Click inside a closed area (or use “Fill whole page”).':
    'Klikněte dovnitř uzavřené plochy (nebo použijte „Vyplnit celou stránku“).',
  'That would be about {n} tiles – make the tile size bigger.':
    'To by bylo asi {n} {n|dlaždice|dlaždice|dlaždic} – zvětšete velikost dlaždic.',
  'The tiles are bigger than this area.':
    'Dlaždice jsou větší než tato plocha.',
  'This adds {n} lines, which may make editing slow. Continue?':
    'Přibude {n} {n|čára|čáry|čar}, což může zpomalit úpravy. Pokračovat?',
  'Added the pattern “{type}” ({n} {n|line|lines}).':
    'Přidán vzor „{type}“ ({n} {n|čára|čáry|čar}).',
  'The rows are wider than this area – use a smaller size.':
    'Řady jsou širší než tato plocha – použijte menší velikost.',
  'This area is too narrow for a row of that width.':
    'Tato plocha je na řadu takové šířky příliš úzká.',
  'Added {rows} {rows|row line|row lines} and {cuts} {cuts|cut|cuts} following the outline.':
    'Přidáno {rows} {rows|čára řady|čáry řad|čar řad} a {cuts} {cuts|řez|řezy|řezů} podél obrysu.',
  'Painted areas are locked or hidden (see Layers).':
    'Vybarvené plochy jsou zamčené nebo skryté (viz Vrstvy).',
  'No closed area here. The red circles show line ends that don’t touch anything.':
    'Tady není uzavřená plocha. Červené kroužky ukazují konce čar, které se ničeho nedotýkají.',
  'No closed area here – make sure the lines meet.':
    'Tady není uzavřená plocha – zkontrolujte, že se čáry stýkají.',
  'Click to select (Shift adds) · drag to move – the nearest corner snaps · drag handles to edit; shared corners move together (Alt detaches) · yellow handles resize a polygon':
    'Kliknutím vyberete (Shift přidá) · tažením posunete – přichytí se nejbližší roh · tažením úchytů upravíte; společné rohy se posouvají spolu (Alt je oddělí) · žluté úchyty mění velikost mnohoúhelníku',
  'Click–click or drag · ends snap to points and onto other lines · Shift: 15° steps · Alt: no snap · Esc: stop':
    'Klik–klik nebo tažení · konce se přichytí k bodům a na jiné čáry · Shift: kroky po 15° · Alt: bez přichytávání · Esc: konec',
  'Click corner by corner · click the first corner, double-click or press Enter to close · Backspace removes the last corner · Esc cancels':
    'Klikejte roh po rohu · tvar uzavřete kliknutím na první roh, dvojklikem nebo klávesou Enter · Backspace odebere poslední roh · Esc zruší',
  'Drag from the center (or along an edge in “From edge” mode) · click = last size · Shift: 15° rotation · Ctrl: flip side · keys 3–9: sides':
    'Táhněte ze středu (nebo podél hrany v režimu „Od hrany“) · kliknutí = poslední velikost · Shift: otočení po 15° · Ctrl: převrátit stranu · klávesy 3–9: počet stran',
  'Drag across a tile to cut it straight through, edge to edge · Shift: 15° steps':
    'Táhněte přes dlaždici a rozřízněte ji rovně od hrany k hraně · Shift: kroky po 15°',
  'Click inside a closed area to fill it with the chosen pattern':
    'Klikněte dovnitř uzavřené plochy a vyplňte ji zvoleným vzorem',
  'Click or drag across tiles to paint them · click again to recolor · ∅ swatch erases · Alt+click: pick a color':
    'Kliknutím nebo tažením přes dlaždice je vybarvíte · dalším kliknutím přebarvíte · vzorník ∅ maže · Alt+klik: vybrat barvu',
  'Drag to pan · mouse wheel zooms':
    'Tažením posunete pohled · kolečko myši přibližuje',
  'The lines layer is locked or hidden (see Layers).':
    'Vrstva čar je zamčená nebo skrytá (viz Vrstvy).',
  'About {n} tiles – too many, use a bigger tile size.':
    'Asi {n} {n|dlaždice|dlaždice|dlaždic} – příliš mnoho, použijte větší dlaždice.',
  'About {n} tiles.':
    'Asi {n} {n|dlaždice|dlaždice|dlaždic}.',
  'Load a photo first.':
    'Nejdřív načtěte fotku.',
  'That gives {n} tiles – use a bigger tile size.':
    'To dává {n} {n|dlaždici|dlaždice|dlaždic} – použijte větší dlaždice.',
  'Before making a mosaic from the photo':
    'Před vytvořením mozaiky z fotky',
  'From photo':
    'Z fotky',
  'New palette “{name}” with {n} {n|color|colors}.':
    'Nová paleta „{name}“ {n|s|se|s} {n} {n|barvou|barvami|barvami}.',
  'Made a mosaic of {n} tiles from the photo.':
    'Z fotky vznikla mozaika z {n} {n|dlaždice|dlaždic|dlaždic}.',
  'Working…':
    'Pracuji…',
  'Make mosaic':
    'Vytvořit mozaiku',
  'Versions are kept in this browser: every few minutes while you work, and before you open, start or restore another drawing. Restoring keeps your current drawing as a version too.':
    'Verze se ukládají v tomto prohlížeči: během práce každých pár minut a také předtím, než otevřete, založíte nebo obnovíte jinou kresbu. Při obnovení se i aktuální kresba uloží jako verze.',
  'No versions yet. A version is kept every few minutes while you work, and before you open or start another drawing.':
    'Zatím žádné verze. Verze se ukládá během práce každých pár minut a předtím, než otevřete nebo založíte jinou kresbu.',
  '{n} painted {n|area|areas}':
    '{n} {n|vybarvená plocha|vybarvené plochy|vybarvených ploch}',
  'Saved by hand':
    'Uloženo ručně',
  'This browser can’t copy images – use PNG to save one instead.':
    'Tento prohlížeč neumí kopírovat obrázky – uložte si místo toho PNG.',
  'Copied the drawing as an image – paste it into the raster app or any other program.':
    'Kresba je zkopírovaná jako obrázek – vložte ji do rastrové aplikace nebo do jakéhokoli programu.',
  'Could not copy the image (the browser refused).':
    'Obrázek nelze zkopírovat (prohlížeč to odmítl).',
  '{n} {n|panel|panels} ({rows} × {cols}) · each printed at real size on {s} {paper} {s|sheet|sheets}.':
    '{n} {n|panel|panely|panelů} ({rows} × {cols}) · každý vytištěný ve skutečné velikosti na {s} {s|list|listy|listů} {paper}.',
  'laying plan: {n} {n|panel|panels} ({rows} rows × {cols} columns) of {w} × {h} {unit}':
    'plán pokládky: {n} {n|panel|panely|panelů} ({rows} řad × {cols} sloupců) o velikosti {w} × {h} {unit}',
  'Panel {n} – row {row}, column {col}':
    'Panel {n} – řada {row}, sloupec {col}',
  'Panel {n}':
    'Panel {n}',
  'Panel':
    'Panel',
  'tiles per panel and color':
    'dlaždice podle panelů a barev',
  'laying plan':
    'plán pokládky',
  '{c} – click to remove from the mix':
    '{c} – kliknutím odeberete ze směsi',
  'Shift+click two or more swatches to put them in the mix.':
    'Shift+klikněte na dva nebo více vzorníků a přidejte je do směsi.',
  'Each tile gets one of these {n} colors at random. Shift+click swatches to change the mix.':
    'Každá dlaždice dostane náhodně jednu z těchto {n} barev. Shift+klikem na vzorníky směs změníte.',
  'Put at least two colors in the mix first (Shift+click swatches).':
    'Nejdřív dejte do směsi aspoň dvě barvy (Shift+klik na vzorníky).',
  'Mixed the colors of {n} {n|area|areas}.':
    'Promíchány barvy {n} {n|plochy|ploch|ploch}.',
  'Select painted areas first.':
    'Nejdřív vyberte vybarvené plochy.',
  'Cut {n} {n|shape|shapes}. Paste with Ctrl+V – also in another page or drawing.':
    'Vyjmuto: {n} {n|tvar|tvary|tvarů}. Vložte pomocí Ctrl+V – i na jinou stránku nebo do jiné kresby.',
  'Copied {n} {n|shape|shapes}. Paste with Ctrl+V – also in another page or drawing.':
    'Zkopírováno: {n} {n|tvar|tvary|tvarů}. Vložte pomocí Ctrl+V – i na jinou stránku nebo do jiné kresby.',
  'Pasted {n} {n|shape|shapes}.':
    'Vloženo: {n} {n|tvar|tvary|tvarů}.',
  'Could not store the motifs.':
    'Motivy nelze uložit.',
  'No motifs yet. Select some shapes and save them.':
    'Zatím žádné motivy. Vyberte nějaké tvary a uložte je.',
  '{name} – click, then click on the drawing to place it':
    '{name} – klikněte a pak kliknutím do kresby motiv umístěte',
  'Delete this motif':
    'Smazat tento motiv',
  'Delete the motif “{name}”?':
    'Smazat motiv „{name}“?',
  'Select the shapes of the motif first (Select tool).':
    'Nejdřív vyberte tvary motivu (nástroj Výběr).',
  'Name of the motif:':
    'Název motivu:',
  'Motif {n}':
    'Motiv {n}',
  'Saved the motif “{name}”.':
    'Motiv „{name}“ je uložen.',
  'This motif could not be read.':
    'Tento motiv nelze načíst.',
  'Placed “{name}”. Click again for another one, R turns it, Esc stops.':
    'Umístěn motiv „{name}“. Dalším kliknutím přidáte další, R otáčí, Esc končí.',
  'Click to place the motif · R: turn it by 15° (Shift+R: 90°) · Esc: stop':
    'Kliknutím umístíte motiv · R: otočit o 15° (Shift+R: o 90°) · Esc: konec',
  'There are no motifs to export yet.':
    'Zatím nejsou žádné motivy k exportu.',
  'Imported {n} {n|motif|motifs}.':
    'Importováno: {n} {n|motiv|motivy|motivů}.',
  'No motifs found in that file.':
    'V tom souboru nejsou žádné motivy.',
  'That file is not a motif library.':
    'Ten soubor není knihovna motivů.',
  'Page {n}':
    'Stránka {n}',
  '{name} copy':
    '{name} – kopie',
  'Page name:':
    'Název stránky:',
  'A project needs at least one page.':
    'Projekt musí mít aspoň jednu stránku.',
  'Delete the page “{name}”? (A copy of the project is kept in History.)':
    'Smazat stránku „{name}“? (Kopie projektu zůstane v Historii.)',
  'Before deleting the page {name}':
    'Před smazáním stránky {name}',
  'Rename…':
    'Přejmenovat…',
  'Duplicate':
    'Duplikovat',
  'Move left':
    'Posunout doleva',
  'Move right':
    'Posunout doprava',
  'Delete…':
    'Smazat…',
  'Double-click to rename':
    'Dvojklikem přejmenujete',
  'Switch to this page':
    'Přepnout na tuto stránku',
  'Page options':
    'Možnosti stránky',
  'Load a photo first (Photo section).':
    'Nejdřív načtěte fotku (sekce Fotka k obkreslení).',
  'The palette is empty – add colors first.':
    'Paleta je prázdná – nejdřív přidejte barvy.',
  'Colored {n} {n|area|areas} with the closest palette colors':
    'Vybarveno {n} {n|plocha|plochy|ploch} nejbližšími barvami palety',
  '{n} already painted (left as they were)':
    '{n} už {n|byla vybarvená|byly vybarvené|bylo vybarvených} (beze změny)',
  '{n} outside the photo':
    '{n} mimo fotku',
  'colors':
    'barvy',
  'The browser blocked the print window – allow pop-ups for this page.':
    'Prohlížeč zablokoval okno tisku – povolte pro tuto stránku vyskakovací okna.',
  'Nothing to import from the raster app.':
    'Z rastrové aplikace není co importovat.',
  'Opened {n} tiles from the raster app – your previous drawing is in History.':
    'Otevřeno {n} {n|dlaždice|dlaždice|dlaždic} z rastrové aplikace – předchozí kresba je v Historii.',
  '<b>{n}</b> painted {n|area|areas} in <b>{c}</b> {c|color|colors}':
    '<b>{n}</b> {n|vybarvená plocha|vybarvené plochy|vybarvených ploch} {c|v|ve|v} <b>{c}</b> {c|barvě|barvách|barvách}',
  '<b>{n}</b> not painted yet':
    '<b>{n}</b> ještě nevybarveno',
  'everything is painted':
    'vše je vybarvené',
  'page {w} × {h} {unit}':
    'stránka {w} × {h} {unit}',
  'Color':
    'Barva',
  'Areas':
    'Plochy',
  'Total area':
    'Celková plocha',
  'Share':
    'Sdílet',
  'Pieces of the size set above, plus waste':
    'Kusy o výše nastavené velikosti, včetně prořezu',
  'Pieces to buy':
    'Kusů ke koupi',
  'Replace with':
    'Nahradit za',
  'Erase':
    'Smazat',
  'Nothing is painted yet. Use the paint bucket, or “Color tiles from photo”.':
    'Zatím není nic vybarveno. Použijte kbelík nebo „Vybarvit dlaždice z fotky“.',
  'Recolored {n} {n|area|areas}.':
    'Přebarveno: {n} {n|plocha|plochy|ploch}.',
  'Erased {n} {n|area|areas}.':
    'Smazáno: {n} {n|plocha|plochy|ploch}.',
  'Colors that may look alike':
    'Barvy, které mohou vypadat podobně',
  '{a} and {b} {how}':
    '{a} a {b} {how}',
  'The link would be {kb} KB – too long. Share the file instead, or leave out the photo.':
    'Odkaz by měl {kb} KB – to je příliš. Sdílejte raději soubor, nebo vynechte fotku.',
  'The link is {kb} KB – long links can get cut off in some messengers; sharing the file is safer. Anyone with it can view the mosaic and make their own copy.':
    'Odkaz má {kb} KB – dlouhé odkazy některé chatovací aplikace zkracují; bezpečnější je sdílet soubor. Kdokoli s odkazem si mozaiku prohlédne a může si udělat vlastní kopii.',
  'The link is {kb} KB. Anyone with it can view the mosaic and make their own copy.':
    'Odkaz má {kb} KB. Kdokoli s odkazem si mozaiku prohlédne a může si udělat vlastní kopii.',
  'Sharing failed.':
    'Sdílení se nezdařilo.',
  'Link copied.':
    'Odkaz je zkopírován.',
  'This share link is damaged or incomplete.':
    'Tento odkaz je poškozený nebo neúplný.',
  'Before opening a shared mosaic':
    'Před otevřením sdílené mozaiky',
  'This is now your own copy – it is saved in this browser like any drawing.':
    'Teď je to vaše vlastní kopie – ukládá se v tomto prohlížeči jako každá kresba.',
  'Normal colors':
    'Běžné barvy',
  'Black & white':
    'Černobíle',
  'Red-blind (protanopia)':
    'Necitlivost na červenou (protanopie)',
  'Green-blind (deuteranopia)':
    'Necitlivost na zelenou (deuteranopie)',
  'Blue-blind (tritanopia)':
    'Necitlivost na modrou (tritanopie)',
  'look almost the same':
    'vypadají skoro stejně',
  'in black & white':
    'černobíle',
  'for red-blind viewers':
    'pro lidi necitlivé na červenou',
  'for green-blind viewers':
    'pro lidi necitlivé na zelenou',
  'for blue-blind viewers':
    'pro lidi necitlivé na modrou',
  'look alike {who}':
    'vypadají podobně {who}',
  '{n} {n|tile blends|tiles blend} into a neighbour of another color.':
    '{n} {n|dlaždice splývá|dlaždice splývají|dlaždic splývá} se sousední dlaždicí jiné barvy.',
  '{n} {n|tile blends|tiles blend} into a neighbour of another color (in this view).':
    '{n} {n|dlaždice splývá|dlaždice splývají|dlaždic splývá} se sousední dlaždicí jiné barvy (v tomto zobrazení).',
  'No tile blends into its neighbours.':
    'Žádná dlaždice nesplývá se sousedními.',
  'Sheet {sheet} – row {row}, column {col} of {cols} · blue strips are covered by the next sheet':
    'List {sheet} – řada {row}, sloupec {col} z {cols} · modré pruhy překryje další list',
  'One {paper} sheet ({orientation}), at {pct} % of the real size.':
    'Jeden list {paper} ({orientation}), {pct} % skutečné velikosti.',
  'One {paper} sheet ({orientation}) at real size.':
    'Jeden list {paper} ({orientation}) ve skutečné velikosti.',
  '{n} {paper} {n|sheet|sheets} ({orientation}, {rows} × {cols}, overlapping {overlap} mm) at real size.':
    '{n} {n|list|listy|listů} {paper} ({orientation}, {rows} × {cols}, s překryvem {overlap} mm) ve skutečné velikosti.',
  '{n} sheets ({rows} × {cols}), real size {w} × {h} cm':
    '{n} listů ({rows} × {cols}), skutečná velikost {w} × {h} cm',
  'The picture has many colors: it is snapped to the current palette (use “Reduce to palette” to see the result first).':
    'Obrázek má mnoho barev: převede se na aktuální paletu (výsledek si nejdřív můžete prohlédnout přes „Převést na paletu“).',
  'The picture has many colors: it is snapped to 8 colors suggested from it.':
    'Obrázek má mnoho barev: převede se na 8 barev navržených z něj.',
  'Images':
    'Obrázky',
  'PNG image':
    'Obrázek PNG',
  'Discard unsaved changes to the current image?\n(Save it first if you want to keep it.)':
    'Zahodit neuložené změny v aktuálním obrázku?\n(Pokud si ho chcete ponechat, nejdřív ho uložte.)',
  'Could not read {name} as an image.':
    'Soubor {name} nelze načíst jako obrázek.',
  'Opened {name} ({w} × {h} px).':
    'Otevřeno: {name} ({w} × {h} px).',
  'Size of the new image in pixels (width × height):':
    'Velikost nového obrázku v pixelech (šířka × výška):',
  'Enter a size like 800 × 600 (at most {max} px a side).':
    'Zadejte velikost jako 800 × 600 (nejvýš {max} px na stranu).',
  'Before starting a new image':
    'Před založením nového obrázku',
  'That version could not be read.':
    'Tuto verzi nelze načíst.',
  'Export failed.':
    'Export se nezdařil.',
  'Autosave failed – remember to save your image.':
    'Automatické ukládání selhalo – nezapomeňte obrázek uložit.',
  'The clipboard has no image or color codes.':
    'Ve schránce není obrázek ani kódy barev.',
  'Versions are kept in this browser: every few minutes while you work, and before you open, start or restore another image. Restoring keeps your current image as a version too.':
    'Verze se ukládají v tomto prohlížeči: během práce každých pár minut a také předtím, než otevřete, založíte nebo obnovíte jiný obrázek. Při obnovení se i aktuální obrázek uloží jako verze.',
  'No versions yet. A version is kept every few minutes while you work, and before you open or start another image.':
    'Zatím žádné verze. Verze se ukládá během práce každých pár minut a předtím, než otevřete nebo založíte jiný obrázek.',
  'The palette is empty – add colors, or let the mosaic suggest some.':
    'Paleta je prázdná – přidejte barvy, nebo nechte mozaiku nějaké navrhnout.',
  'There is nothing to make a mosaic from (the area is transparent).':
    'Není z čeho udělat mozaiku (plocha je průhledná).',
  'From picture':
    'Z obrázku',
  'Made {n} {n|tile|tiles} in {c} {c|color|colors}.':
    'Vytvořeno {n} {n|dlaždice|dlaždice|dlaždic} {c|v|ve|v} {c} {c|barvě|barvách|barvách}.',
  'The palette is empty.':
    'Paleta je prázdná.',
  'Every pixel now has a palette color: {n} {n|pixel|pixels} in {c} {c|color|colors}.':
    'Každý pixel má teď barvu z palety: {n} {n|pixel|pixely|pixelů} {c|v|ve|v} {c} {c|barvě|barvách|barvách}.',
  'At most about {n} tiles in the selection – bigger ones where the picture is calm.':
    'Nejvýš asi {n} {n|dlaždice|dlaždice|dlaždic} ve výběru – kde je obrázek klidný, budou větší.',
  'At most about {n} tiles – bigger ones where the picture is calm.':
    'Nejvýš asi {n} {n|dlaždice|dlaždice|dlaždic} – kde je obrázek klidný, budou větší.',
  'About {n} tiles in the selection.':
    'Asi {n} {n|dlaždice|dlaždice|dlaždic} ve výběru.',
  'Turn on “Fill” or “Outline” for polygons.':
    'U mnohoúhelníků zapněte „Výplň“ nebo „Obrys“.',
  'Picked “transparent”.':
    'Vybrána „průhledná“.',
  'Picked {c} (not in the palette – add it with “From image”).':
    'Vybrána barva {c} (není v paletě – přidejte ji tlačítkem „Z obrázku“).',
  '{n} {n|pixel|pixels}':
    '{n} {n|pixel|pixely|pixelů}',
  'paint color':
    'barva malování',
  'outline color':
    'barva obrysu',
  'Transparent – paints and fills transparent pixels':
    'Průhledná – maluje a vyplňuje průhlednými pixely',
  'Recolored {n} {n|pixel|pixels}.':
    'Přebarveno: {n} {n|pixel|pixely|pixelů}.',
  'Nothing to paste – or the browser didn’t allow reading the clipboard (try Ctrl+V).':
    'Není co vložit – nebo prohlížeč nepovolil čtení schránky (zkuste Ctrl+V).',
  'Enter a size from 1 to {max} px.':
    'Zadejte velikost od 1 do {max} px.',
  'This picture has {n} pieces – too many to number. Make a mosaic or reduce it to the palette first.':
    'Obrázek má {n} {n|dílek|dílky|dílků} – to je na číslování příliš. Nejdřív z něj udělejte mozaiku nebo ho převeďte na paletu.',
  '{n} {n|piece|pieces}':
    '{n} {n|dílek|dílky|dílků}',
  '{n} {n|piece|pieces} in {c} {c|color|colors} · {w} × {h} px':
    '{n} {n|dílek|dílky|dílků} {c|v|ve|v} {c} {c|barvě|barvách|barvách} · {w} × {h} px',
  'Nothing is painted yet.':
    'Zatím není nic vybarveno.',
  '{w} × {h} mm · {k} mm per pixel':
    '{w} × {h} mm · {k} mm na pixel',
  'Pieces':
    'Dílky',
  'Pixels':
    'Pixely',
  'Area':
    'Plocha',
  'transparent':
    'průhledná',
  '({w} × {h} px, not placed yet)':
    '({w} × {h} px, ještě neumístěno)',
  'Cut the selection – paste it here, into the vector app or any other program.':
    'Výběr je vyjmutý – vložte ho sem, do vektorové aplikace nebo do jakéhokoli programu.',
  'Cut the image – paste it here, into the vector app or any other program.':
    'Obrázek je vyjmutý – vložte ho sem, do vektorové aplikace nebo do jakéhokoli programu.',
  'Copied the selection – paste it here, into the vector app or any other program.':
    'Výběr je zkopírovaný – vložte ho sem, do vektorové aplikace nebo do jakéhokoli programu.',
  'Copied the image – paste it here, into the vector app or any other program.':
    'Obrázek je zkopírovaný – vložte ho sem, do vektorové aplikace nebo do jakéhokoli programu.',
  'Cut the selection (this browser keeps it for pasting here only).':
    'Výběr je vyjmutý (tento prohlížeč ho uchová jen pro vložení sem).',
  'Cut the image (this browser keeps it for pasting here only).':
    'Obrázek je vyjmutý (tento prohlížeč ho uchová jen pro vložení sem).',
  'Copied the selection (this browser keeps it for pasting here only).':
    'Výběr je zkopírovaný (tento prohlížeč ho uchová jen pro vložení sem).',
  'Copied the image (this browser keeps it for pasting here only).':
    'Obrázek je zkopírovaný (tento prohlížeč ho uchová jen pro vložení sem).',
  'Select the part to keep first.':
    'Nejdřív vyberte část, kterou chcete ponechat.',
  'Could not read the pasted image.':
    'Vložený obrázek nelze načíst.',
  'The pasted image ({w} × {h}) is bigger than this one ({W} × {H}). Enlarge the canvas to fit it?':
    'Vložený obrázek ({w} × {h}) je větší než tento ({W} × {H}). Zvětšit plátno, aby se vešel?',
  'Pasted {w} × {h} px – drag it into place, then press Enter (or click outside it).':
    'Vloženo {w} × {h} px – přetáhněte na místo a stiskněte Enter (nebo klikněte mimo).',
  'The link would be {kb} KB – too long. Share the file instead (or make the image smaller).':
    'Odkaz by měl {kb} KB – to je příliš. Sdílejte raději soubor (nebo obrázek zmenšete).',
  'The link is {kb} KB – long links can get cut off in some messengers; sharing the file is safer. Anyone with it can view the image and make their own copy.':
    'Odkaz má {kb} KB – dlouhé odkazy některé chatovací aplikace zkracují; bezpečnější je sdílet soubor. Kdokoli s odkazem si obrázek prohlédne a může si udělat vlastní kopii.',
  'The link is {kb} KB. Anyone with it can view the image and make their own copy.':
    'Odkaz má {kb} KB. Kdokoli s odkazem si obrázek prohlédne a může si udělat vlastní kopii.',
  'Before opening a shared image':
    'Před otevřením sdíleného obrázku',
  'This is now your own copy – it is saved in this browser like any image.':
    'Teď je to vaše vlastní kopie – ukládá se v tomto prohlížeči jako každý obrázek.',
  'Drag to select · drag inside the selection to move it (Alt: a copy) · Enter places it · Ctrl+C / X / V copy, cut, paste':
    'Tažením vyberete · tažením uvnitř výběru ho posunete (Alt: kopii) · Enter ho umístí · Ctrl+C / X / V kopírovat, vyjmout, vložit',
  'Drag to paint · Shift: straight line · [ ] size · Shift+B: tip · Alt+click: pick a color':
    'Tažením malujete · Shift: rovná čára · [ ] velikost · Shift+B: hrot · Alt+klik: vybrat barvu',
  'Hard pixels in exact colors · Shift: straight line · [ ] size · Alt+click: pick a color':
    'Ostré pixely v přesných barvách · Shift: rovná čára · [ ] velikost · Alt+klik: vybrat barvu',
  'Drag to erase to transparent · Shift: straight line · [ ] size':
    'Tažením mažete do průhlednosti · Shift: rovná čára · [ ] velikost',
  'Drag a line · Shift: 15° steps':
    'Táhněte čáru · Shift: kroky po 15°',
  'Drag from the center · Shift: 15° rotation · keys 3–9: sides':
    'Táhněte ze středu · Shift: otočení po 15° · klávesy 3–9: počet stran',
  'Click to fill the area of similar color · Alt+click: pick a color':
    'Kliknutím vyplníte plochu podobné barvy · Alt+klik: vybrat barvu',
  'Click to take a color from the image':
    'Kliknutím vezmete barvu z obrázku',
  'No grout – every piece is a tile':
    'Bez spár – každý dílek je dlaždice',
  '{n} {n|tile|tiles} at {w} × {h} mm – too many: make a mosaic or reduce the picture to the palette first.':
    '{n} {n|dlaždice|dlaždice|dlaždic} na {w} × {h} mm – příliš mnoho: nejdřív udělejte mozaiku nebo převeďte obrázek na paletu.',
  '{n} {n|tile|tiles} at {w} × {h} mm.':
    '{n} {n|dlaždice|dlaždice|dlaždic} na {w} × {h} mm.',
  'Could not hand the tiles over (browser storage unavailable).':
    'Dlaždice nelze předat (úložiště prohlížeče není dostupné).',
  '3D print':
    '3D tisk',
  'Close':
    'Zavřít',
  'A model where every color stands at its own height. Print it with one nozzle and change the filament at the layers listed below – each tile’s top then shows its color. The 3MF file already contains the filament changes for PrusaSlicer; for other slicers, the plan lists them.':
    'Model, ve kterém má každá barva svou výšku. Vytiskněte ho jednou tryskou a ve vrstvách uvedených níže vyměňte filament – horní plocha každé dlaždice pak má svou barvu. Soubor 3MF už výměny filamentu obsahuje pro PrusaSlicer; pro jiné sliceře je najdete v plánu.',
  'Size':
    'Velikost',
  'Size of the model’s smallest step – about your nozzle width':
    'Velikost nejmenšího kroku modelu – zhruba šířka vaší trysky',
  'Detail':
    'Detail',
  'Layer height':
    'Výška vrstvy',
  'How many layers each color gets – more layers cover the color below better':
    'Kolik vrstev dostane každá barva – víc vrstev lépe překryje barvu pod ní',
  'Layers per color':
    'Vrstev na barvu',
  'A plate under everything, printed in the first color. 0: unpainted parts are left open':
    'Deska pod vším, tištěná první barvou. 0: nevybarvená místa zůstanou otevřená',
  'Base layers':
    'Vrstev základu',
  'Top view of the model':
    'Pohled na model shora',
  'Print order (bottom first):':
    'Pořadí tisku (odspodu):',
  'Lighter colors lower: a darker layer covers a lighter one well. Lines (grout) stay at the bottom':
    'Světlejší barvy níž: tmavší vrstva světlejší dobře překryje. Čáry (spáry) zůstávají dole',
  'Light → dark':
    'Světlé → tmavé',
  'Dark → light':
    'Tmavé → světlé',
  'Which filament to load at which layer, as a text file':
    'Který filament ve které vrstvě založit, jako textový soubor',
  'Plan':
    'Plán',
  'Just the shape – add the filament changes from the plan in your slicer':
    'Jen tvar – výměny filamentu podle plánu přidejte ve sliceru',
  'The model, with the filament changes for PrusaSlicer':
    'Model i s výměnami filamentu pro PrusaSlicer',
  'Download 3MF':
    'Stáhnout 3MF',
  '{n} colors make a tall print with many filament changes – reduce the colors first (Raster: “Reduce to palette”).':
    '{n} {n|barva dává|barvy dávají|barev dává} vysoký výtisk s mnoha výměnami filamentu – nejdřív snižte počet barev (Rastr: „Převést na paletu“).',
  'Detail lowered to {d} mm for this size.':
    'Detail snížen na {d} mm kvůli této velikosti.',
  'lines':
    'čáry',
  'Print earlier (lower)':
    'Tisknout dřív (níž)',
  'Print later (higher)':
    'Tisknout později (výš)',
  '{share} % · layers {from}–{to}':
    '{share} % · vrstvy {from}–{to}',
  '{share} % · layers {from}–{to} · change at Z {z}':
    '{share} % · vrstvy {from}–{to} · výměna ve výšce Z {z}',
  '{n} {n|color|colors} · height {h} mm ({layers} {layers|layer|layers}) · {c} filament {c|change|changes}':
    '{n} {n|barva|barvy|barev} · výška {h} mm ({layers} {layers|vrstva|vrstvy|vrstev}) · {c} {c|výměna|výměny|výměn} filamentu',
  'unpainted parts stay at the base ({h} mm)':
    'nevybarvená místa zůstanou ve výšce základu ({h} mm)',
  'unpainted parts are left open':
    'nevybarvená místa zůstanou otevřená',
  'Mosaic Paint – 3D print plan for {name}.3mf / {name}.stl':
    'Mosaic Paint – plán 3D tisku pro {name}.3mf / {name}.stl',
  'Size {w} × {h} mm · layer height {lh} mm · {lpc} layers per color · base {base} layers':
    'Velikost {w} × {h} mm · výška vrstvy {lh} mm · {lpc} vrstev na barvu · základ {base} vrstev',
  'Total height {total} mm ({layers} layers). Set the slicer’s first layer height to {lh} mm too.':
    'Celková výška {total} mm ({layers} vrstev). Výšku první vrstvy ve sliceru nastavte také na {lh} mm.',
  'Start with {color} – layers {from}–{to} (base plate included)':
    'Začněte barvou {color} – vrstvy {from}–{to} (včetně základní desky)',
  'Start with {color} – layers {from}–{to}':
    'Začněte barvou {color} – vrstvy {from}–{to}',
  'Layer {layer} (Z {z} mm): change to {color} – layers {from}–{to}':
    'Vrstva {layer} (Z {z} mm): vyměňte za {color} – vrstvy {from}–{to}',
  'PrusaSlicer: the 3MF file already contains these changes – open it and check the layer slider.':
    'PrusaSlicer: soubor 3MF už tyto výměny obsahuje – otevřete ho a zkontrolujte posuvník vrstev.',
  'Other slicers (they read only the shape from the 3MF or STL) – add the changes by hand:':
    'Jiné sliceře (z 3MF nebo STL načtou jen tvar) – výměny přidejte ručně:',
  '- PrusaSlicer, Bambu Studio, OrcaSlicer: in the preview, move the layer slider to each Z above and click “+” (Add color change, M600).':
    '- PrusaSlicer, Bambu Studio, OrcaSlicer: v náhledu posuňte posuvník vrstev na každou výšku Z výše a klikněte na „+“ (Přidat změnu barvy, M600).',
  '- Cura: Extensions › Post Processing › Modify G-Code › “Filament Change” at each layer number above.':
    '- Cura: Rozšíření › Postprocessing › Upravit G-kód › „Filament Change“ u každého čísla vrstvy výše.',
  '- Multi-material printers (AMS, MMU): the same changes work; or assign the filaments to the color changes in the slicer.':
    '- Tiskárny pro více materiálů (AMS, MMU): fungují stejné výměny; nebo přiřaďte filamenty ke změnám barvy ve sliceru.',
  'Could not read the picture.':
    'Obrázek nelze načíst.',
  'Saved {name}.3mf ({n} triangles; PrusaSlicer reads its {c} filament {c|change|changes}, other slicers need the plan).':
    'Uloženo {name}.3mf ({n} trojúhelníků; PrusaSlicer načte {c} {c|výměnu|výměny|výměn} filamentu, jiné sliceře potřebují plán).',
  'Saved {name}.stl ({n} triangles). Add the filament changes from the plan in your slicer.':
    'Uloženo {name}.stl ({n} trojúhelníků). Výměny filamentu podle plánu přidejte ve sliceru.',
  'Reading the picture…':
    'Načítám obrázek…',
  'History':
    'Historie',
  'Save a version now':
    'Uložit verzi teď',
  'Version history needs browser storage (IndexedDB), which is not available here.':
    'Historie verzí potřebuje úložiště prohlížeče (IndexedDB), které tu není dostupné.',
  'Restore':
    'Obnovit',
  'Version saved.':
    'Verze je uložena.',
  'Could not save a version (browser storage unavailable).':
    'Verzi nelze uložit (úložiště prohlížeče není dostupné).',
  'used by {what}':
    'použito: {what}',
  'Click: {fill} · Right-click: {stroke} · Double-click: edit':
    'Klik: {fill} · Pravý klik: {stroke} · Dvojklik: upravit',
  'Remove from palette':
    'Odebrat z palety',
  'Edit color (hex or any CSS color).\nThe drawing is recolored too.':
    'Upravit barvu (hex nebo jakákoli barva CSS).\nPřebarví se i kresba.',
  'Not a valid color: {v}':
    'Neplatná barva: {v}',
  'Paste a color code (or several) into the box, then press Enter.':
    'Vložte do pole kód barvy (nebo několik) a stiskněte Enter.',
  'No color found in: {text}':
    'Nenalezena žádná barva v: {text}',
  'Added {n} {n|color|colors}.':
    'Přidáno: {n} {n|barva|barvy|barev}.',
  'Already in the palette.':
    'Už je v paletě.',
  'Added {n} {n|color|colors} from the clipboard.':
    'Ze schránky přidáno: {n} {n|barva|barvy|barev}.',
  'Those colors are already in the palette.':
    'Tyto barvy už v paletě jsou.',
  'Name of the new palette:':
    'Název nové palety:',
  'Palette':
    'Paleta',
  'Created “{name}”. Paste colors to fill it.':
    'Vytvořena paleta „{name}“. Naplňte ji vložením barev.',
  'Rename palette:':
    'Přejmenovat paletu:',
  'Delete the palette “{name}”? (The drawing is not changed.)':
    'Smazat paletu „{name}“? (Kresba se nezmění.)',
  'Added {n} {n|color|colors} from the drawing.':
    'Z kresby přidáno: {n} {n|barva|barvy|barev}.',
  'No new colors in the drawing.':
    'V kresbě nejsou žádné nové barvy.',
  'Remove all colors from this palette? (The drawing is not changed.)':
    'Odebrat z této palety všechny barvy? (Kresba se nezmění.)',
  'Imported {n} {n|color|colors}.':
    'Importováno: {n} {n|barva|barvy|barev}.',
  'No new colors found in {name}':
    'V souboru {name} nejsou žádné nové barvy',
  'Installed – Mosaic Paint now works offline too.':
    'Nainstalováno – Mosaic Paint teď funguje i offline.',
  'Simple':
    'Jednoduchý',
  'Expert':
    'Expert',
  'New':
    'Nový',
  'Open…':
    'Otevřít…',
  'Save':
    'Uložit',
  'Save as…':
    'Uložit jako…',
  'Copy image':
    'Kopírovat obrázek',
  'Print…':
    'Tisk…',
  'Plan…':
    'Plán…',
  'Report':
    'Přehled',
  'Contrast':
    'Kontrast',
  'Share of area':
    'Podíl plochy',
  'Install app':
    'Nainstalovat aplikaci',
  'You are looking at a shared mosaic.':
    'Prohlížíte si sdílenou mozaiku.',
  'Make my own copy':
    'Udělat si vlastní kopii',
  'Back to my drawing':
    'Zpět k mé kresbě',
  'Remove last corner':
    'Odebrat poslední roh',
  'Cancel':
    'Zrušit',
  'Colors':
    'Barvy',
  'Fill':
    'Výplň',
  'Stroke':
    'Obrys',
  'Width':
    'Šířka',
  'Add color':
    'Přidat barvu',
  'Import…':
    'Importovat…',
  'From drawing':
    'Z kresby',
  'Export':
    'Exportovat',
  'Clear':
    'Vymazat',
  'Click a swatch = fill · right-click = stroke · double-click = edit (also recolors the drawing) · Shift+click = add to the color mix. Ctrl+V on the canvas adds copied colors.':
    'Klik na vzorník = výplň · pravý klik = obrys · dvojklik = upravit (přebarví i kresbu) · Shift+klik = přidat do směsi barev. Ctrl+V na plátně přidá zkopírované barvy.',
  'Line':
    'Čára',
  'Chain lines (next line starts at the last end)':
    'Navazovat čáry (další čára začne na konci předchozí)',
  'Free polygon':
    'Volný mnohoúhelník',
  'Click each corner. Click the first corner again, double-click or press Enter to close it.':
    'Klikněte na každý roh. Tvar uzavřete kliknutím na první roh, dvojklikem nebo klávesou Enter.',
  'Fill new shapes with the fill color':
    'Nové tvary vyplnit barvou výplně',
  'Regular polygon':
    'Pravidelný mnohoúhelník',
  'Sides':
    'Strany',
  'From center':
    'Ze středu',
  'From edge':
    'Od hrany',
  'Knife':
    'Nůž',
  'Press inside a tile and drag in the direction of the cut. The tile is cut straight across, from edge to edge.':
    'Stiskněte uvnitř dlaždice a táhněte ve směru řezu. Dlaždice se rozřízne rovně od hrany k hraně.',
  'Pattern':
    'Vzor',
  'Angle':
    'Úhel',
  'Rows':
    'Řady',
  'Fill whole page':
    'Vyplnit celou stránku',
  'Click inside a closed area to fill it with tiles. Painted areas keep their color in every new tile. “Rows following the outline” lays rows along the area’s edge and around shapes inside it (Rows 0 = fill it).':
    'Klikněte dovnitř uzavřené plochy a vyplňte ji dlaždicemi. Vybarvené plochy si barvu ponechají v každé nové dlaždici. „Řady podél obrysu“ kladou řady podél okraje plochy a kolem tvarů uvnitř ní (Řady 0 = vyplnit celou).',
  'Paint bucket':
    'Kbelík',
  'Click inside any closed area, or drag across many tiles. Click a painted area again to recolor it. The ∅ swatch erases. Alt+click picks a color.':
    'Klikněte do libovolné uzavřené plochy nebo táhněte přes víc dlaždic. Dalším kliknutím vybarvenou plochu přebarvíte. Vzorník ∅ maže. Alt+klik vybere barvu.',
  'Mix colors (a random one per tile)':
    'Míchat barvy (každá dlaždice náhodnou)',
  'Avoid the same color next to itself':
    'Nedávat stejnou barvu vedle sebe',
  'Close gaps up to':
    'Uzavírat mezery do',
  'Photo to trace':
    'Fotka k obkreslení',
  'Opacity':
    'Krytí',
  'Show':
    'Zobrazit',
  'Locked':
    'Zamčeno',
  'Fit to page':
    'Přizpůsobit stránce',
  'Remove':
    'Odstranit',
  'Keep the photo in saved files':
    'Ukládat fotku do souborů',
  'Make a mosaic from the photo…':
    'Vytvořit mozaiku z fotky…',
  'Color my tiles from the photo':
    'Vybarvit mé dlaždice podle fotky',
  'Only tiles that aren’t painted yet':
    'Jen dlaždice, které ještě nejsou vybarvené',
  'Each tile gets the palette color closest to the photo underneath it. Draw the tile lines first.':
    'Každá dlaždice dostane barvu z palety nejbližší fotce pod ní. Nejdřív nakreslete čáry dlaždic.',
  'Grout preview':
    'Náhled spár',
  'Preview':
    'Náhled',
  'Apply to all lines':
    'Použít na všechny čáry',
  'Motifs':
    'Motivy',
  'Save selection…':
    'Uložit výběr…',
  'Click a motif, then click on the drawing to place it (R turns it, Esc stops). Ctrl+C / Ctrl+X / Ctrl+V copy shapes between pages, drawings and browser tabs.':
    'Klikněte na motiv a pak kliknutím do kresby ho umístěte (R otáčí, Esc končí). Ctrl+C / Ctrl+X / Ctrl+V kopírují tvary mezi stránkami, kresbami i panely prohlížeče.',
  'Symmetry':
    'Symetrie',
  'Off':
    'Vypnuto',
  'Mirror left ↔ right':
    'Zrcadlit vlevo ↔ vpravo',
  'Mirror top ↕ bottom':
    'Zrcadlit nahoře ↕ dole',
  'Mirror both ways':
    'Zrcadlit oběma směry',
  'Rotate around center':
    'Otáčet kolem středu',
  'Copies':
    'Kopie',
  'also mirrored':
    'i zrcadlově',
  'Pick center':
    'Vybrat střed',
  'Page center':
    'Střed stránky',
  'Lines, polygons, knife cuts and painting are repeated around the guides.':
    'Čáry, mnohoúhelníky, řezy nožem i vybarvování se opakují kolem vodítek.',
  'Layers':
    'Vrstvy',
  'Lines & shapes':
    'Čáry a tvary',
  'Painted areas':
    'Vybarvené plochy',
  'Photo':
    'Fotka',
  'Lock the lines while painting so they can’t be moved by accident.':
    'Při vybarvování čáry zamkněte, aby se omylem neposunuly.',
  'Snapping':
    'Přichytávání',
  'Snap to points & lines':
    'Přichytávat k bodům a čarám',
  'Shared corners move together':
    'Společné rohy se posouvají spolu',
  'Page edge counts as a line':
    'Okraj stránky se počítá jako čára',
  'Grid, size':
    'Mřížka, velikost',
  'Snaps to ends & corners ▢, crossings ✕, midpoints △, anywhere along a line ◇, centers ○. Hold Alt to place freely.':
    'Přichytává ke koncům a rohům ▢, průsečíkům ✕, středům úseček △, kamkoli na čáru ◇ a středům ○. Se stisknutým Alt umisťujete volně.',
  'Selection':
    'Výběr',
  'Radius':
    'Poloměr',
  'Rotation°':
    'Otočení°',
  'Line width':
    'Šířka čáry',
  'Delete':
    'Smazat',
  'To front':
    'Dopředu',
  'To back':
    'Dozadu',
  'Mix colors':
    'Promíchat barvy',
  'Page':
    'Stránka',
  'Apply':
    'Použít',
  'Background':
    'Pozadí',
  'Show rulers':
    'Zobrazit pravítka',
  'Keyboard & mouse':
    'Klávesnice a myš',
  'Select, Line, Free polygon, Polygon, Ellipse, Curve, Pattern, Bucket, Pan':
    'Výběr, Čára, Volný mnohoúhelník, Mnohoúhelník, Elipsa, Křivka, Vzor, Kbelík, Posun',
  'Polygon sides':
    'Počet stran mnohoúhelníku',
  'Toggle snapping':
    'Zapnout / vypnout přichytávání',
  'Alt':
    'Alt',
  'Draw / drag without snapping; detach a shared corner; Alt+click with the bucket picks a color':
    'Kreslit / táhnout bez přichytávání; oddělit společný roh; Alt+klik kbelíkem vybere barvu',
  'Shift':
    'Shift',
  '15° steps; add to selection':
    'Kroky po 15°; přidat k výběru',
  'Ctrl (polygon tool)':
    'Ctrl (nástroj mnohoúhelník)',
  'Flip side when drawing from an edge':
    'Při kreslení od hrany převrátit stranu',
  'Ctrl + drag handle':
    'Ctrl + tažení úchytu',
  'Freely move a polygon corner (it stops being regular)':
    'Volně posunout roh mnohoúhelníku (přestane být pravidelný)',
  'Enter / Esc':
    'Enter / Esc',
  'Finish / cancel the current shape':
    'Dokončit / zrušit rozkreslený tvar',
  'Del':
    'Del',
  'Delete selection (or the last corner of a free polygon)':
    'Smazat výběr (nebo poslední roh volného mnohoúhelníku)',
  'Arrows':
    'Šipky',
  'Nudge (Shift = ×10)':
    'Posunout (Shift = ×10)',
  'Undo / redo':
    'Zpět / znovu',
  'Copy, cut, paste shapes (also between pages and drawings). Ctrl+C with nothing selected copies the drawing as an image; pasting an image makes it the photo to trace':
    'Kopírovat, vyjmout, vložit tvary (i mezi stránkami a kresbami). Ctrl+C bez výběru zkopíruje kresbu jako obrázek; vložený obrázek se stane fotkou k obkreslení',
  'Duplicate, select all':
    'Duplikovat, vybrat vše',
  'Wheel, Space+drag':
    'Kolečko, mezerník+tažení',
  'Zoom, pan (two fingers on touch screens)':
    'Přiblížení, posun (na dotykových displejích dvěma prsty)',
  'Fit page':
    'Celá stránka',
  '＋ Page':
    '＋ Stránka',
  'Colors & shopping list':
    'Barvy a nákupní seznam',
  'Piece size':
    'Velikost kusu',
  'Waste':
    'Prořez',
  '“Replace with” recolors every area of that color.':
    '„Nahradit za“ přebarví všechny plochy té barvy.',
  'Download CSV':
    'Stáhnout CSV',
  'Print template':
    'Tisková šablona',
  'Opens a print page to use as a cutting or laying template.':
    'Otevře stránku k tisku, kterou použijete jako šablonu pro řezání nebo pokládku.',
  'Paper':
    'Papír',
  'Letter':
    'Letter',
  'Tabloid (11×17 in)':
    'Tabloid (11×17 palců)',
  'Real size (split across several sheets if needed)':
    'Skutečná velikost (v případě potřeby na více listů)',
  'Fit on one sheet':
    'Na jeden list',
  'In color':
    'Barevně',
  'In color, with color numbers':
    'Barevně, s čísly barev',
  'Outlines with color numbers (paint by number)':
    'Obrysy s čísly barev (omalovánka podle čísel)',
  'Add a page with the color legend':
    'Přidat stránku s legendou barev',
  'Mosaic from photo':
    'Mozaika z fotky',
  'Lays out tiles over the whole page and gives each tile the color of the photo underneath it.':
    'Rozloží dlaždice po celé stránce a každé dá barvu fotky pod ní.',
  'First load a photo:':
    'Nejdřív načtěte fotku:',
  'Tiles':
    'Dlaždice',
  'Smaller tiles where the photo has detail':
    'Menší dlaždice tam, kde má fotka detaily',
  'Use the current palette':
    'Použít aktuální paletu',
  'Suggest':
    'Navrhnout',
  'colors from the photo (new palette)':
    'barev z fotky (nová paleta)',
  'Replace the current drawing (it is kept in History)':
    'Nahradit aktuální kresbu (zůstane v Historii)',
  'Laying plan':
    'Plán pokládky',
  'Splits the mosaic into numbered panels – the size of your work surface or of the mesh sheets you lay the tiles on. The print has an overview, every panel at real size and the number of tiles of each color per panel.':
    'Rozdělí mozaiku na očíslované panely – o velikosti vaší pracovní plochy nebo sítí, na které dlaždice kladete. Výtisk obsahuje přehled, každý panel ve skutečné velikosti a počet dlaždic každé barvy v panelu.',
  'Panel size':
    'Velikost panelu',
  'Tabloid':
    'Tabloid',
  'Color numbers on the tiles':
    'Čísla barev na dlaždicích',
  'Show the panels on the drawing':
    'Zobrazit panely v kresbě',
  'The whole drawing is packed into the link itself – nothing is uploaded. Whoever opens it sees the mosaic and can make their own copy to edit.':
    'Celá kresba je zabalená přímo v odkazu – nic se nikam nenahrává. Kdo ho otevře, uvidí mozaiku a může si udělat vlastní kopii k úpravám.',
  'Include the tracing photo (makes the link much longer)':
    'Přibalit fotku k obkreslení (odkaz bude mnohem delší)',
  'Share file…':
    'Sdílet soubor…',
  'Copy link':
    'Kopírovat odkaz',
  'Switch app':
    'Přepnout aplikaci',
  'Vector: tiles as shapes. Raster: paint with pixels. Palettes are shared; copy and paste images between them.':
    'Vektor: dlaždice jako tvary. Rastr: malování pixely. Palety jsou společné; obrázky mezi nimi kopírujte a vkládejte.',
  'Simple shows the essentials; Expert adds symmetry, layers, rulers, the knife, printing and fine settings':
    'Jednoduchý ukazuje to podstatné; Expert přidává symetrii, vrstvy, pravítka, nůž, tisk a jemná nastavení',
  'New drawing':
    'Nová kresba',
  'Open SVG (Ctrl+O) – you can also drop a file on the canvas':
    'Otevřít SVG (Ctrl+O) – soubor můžete také přetáhnout na plátno',
  'Save SVG (Ctrl+S)':
    'Uložit SVG (Ctrl+S)',
  'Save as (Ctrl+Shift+S)':
    'Uložit jako (Ctrl+Shift+S)',
  'Export a PNG image':
    'Exportovat obrázek PNG',
  'Export a 3D model for printing with filament changes – each color at its own height':
    'Exportovat 3D model pro tisk s výměnami filamentu – každá barva ve své výšce',
  'Copy the drawing (or the selected shapes) as an image – paste it into the raster app or any other program (Ctrl+C)':
    'Zkopírovat kresbu (nebo vybrané tvary) jako obrázek – vložíte ho do rastrové aplikace nebo jakéhokoli programu (Ctrl+C)',
  'Print a real-size template with color numbers':
    'Vytisknout šablonu ve skutečné velikosti s čísly barev',
  'Split the mosaic into numbered panels and print a laying plan':
    'Rozdělit mozaiku na očíslované panely a vytisknout plán pokládky',
  'Colors used, areas and a shopping list':
    'Použité barvy, plochy a nákupní seznam',
  'Earlier versions of your drawing':
    'Starší verze vaší kresby',
  'Share the mosaic as a link':
    'Sdílet mozaiku jako odkaz',
  'Undo (Ctrl+Z)':
    'Zpět (Ctrl+Z)',
  'Redo (Ctrl+Y)':
    'Znovu (Ctrl+Y)',
  'Zoom out (-)':
    'Oddálit (-)',
  'Zoom in (+)':
    'Přiblížit (+)',
  'Fit page (0)':
    'Celá stránka (0)',
  'See the mosaic in black & white or as color-blind people see it (screen only)':
    'Zobrazit mozaiku černobíle nebo tak, jak ji vidí lidé s poruchou barvocitu (jen na obrazovce)',
  'Mark tiles that blend into a neighbouring tile of another color':
    'Označit dlaždice, které splývají se sousední dlaždicí jiné barvy',
  'Language':
    'Jazyk',
  'Install as an app that also works offline':
    'Nainstalovat jako aplikaci, která funguje i offline',
  'Show the side panel':
    'Zobrazit boční panel',
  'Select / edit (V)':
    'Výběr / úpravy (V)',
  'Line (L)':
    'Čára (L)',
  'Free polygon – click corner by corner (P)':
    'Volný mnohoúhelník – klikání roh po rohu (P)',
  'Regular polygon (G)':
    'Pravidelný mnohoúhelník (G)',
  'Knife – cut a tile straight across (K)':
    'Nůž – rozříznout dlaždici napříč (K)',
  'Pattern – fill an area with tiles (T)':
    'Vzor – vyplnit plochu dlaždicemi (T)',
  'Paint bucket – click or drag across tiles (B)':
    'Kbelík – klik nebo tažení přes dlaždice (B)',
  'Pan (H, or hold Space / middle mouse / two fingers)':
    'Posun (H, nebo podržte mezerník / prostřední tlačítko myši / dva prsty)',
  'Your saved palettes':
    'Vaše uložené palety',
  'New palette':
    'Nová paleta',
  'Rename this palette':
    'Přejmenovat tuto paletu',
  'Delete this palette':
    'Smazat tuto paletu',
  'Fill color – used by the paint bucket':
    'Barva výplně – používá ji kbelík',
  'Stroke color – used for new lines and polygons':
    'Barva obrysu – pro nové čáry a mnohoúhelníky',
  'Swap fill and stroke':
    'Prohodit výplň a obrys',
  'Line width for new lines and polygons':
    'Šířka čáry pro nové čáry a mnohoúhelníky',
  'Paste #hex, rgb(), name…':
    'Vložte #hex, rgb(), název…',
  'Load colors from a .txt / .gpl / .css file':
    'Načíst barvy ze souboru .txt / .gpl / .css',
  'Add every color used in the drawing':
    'Přidat všechny barvy použité v kresbě',
  'Download the palette as a list of hex codes':
    'Stáhnout paletu jako seznam kódů hex',
  '0 = as many rows as fit':
    '0 = tolik řad, kolik se vejde',
  'Lay out tiles over the whole page and color them from the photo':
    'Rozložit dlaždice po celé stránce a vybarvit je podle fotky',
  'Color the tiles you have drawn':
    'Vybarvit dlaždice, které jste nakreslili',
  'Grout color':
    'Barva spár',
  'Give every line this color and width for real':
    'Opravdu dát všem čarám tuto barvu a šířku',
  'Save the selected shapes as a motif':
    'Uložit vybrané tvary jako motiv',
  'Load motifs from a file':
    'Načíst motivy ze souboru',
  'Download all motifs as a file':
    'Stáhnout všechny motivy jako soubor',
  'Give the selected painted areas random colors from the mix':
    'Dát vybraným vybarveným plochám náhodné barvy ze směsi',
  'Real-world unit: 1 drawing unit = 1 mm / cm / inch':
    'Skutečná jednotka: 1 jednotka kresby = 1 mm / cm / palec',
  'Add a page (front, back, a color variant…)':
    'Přidat stránku (přední strana, zadní strana, barevná varianta…)',
  'Export…':
    'Exportovat…',
  'Copy':
    'Kopírovat',
  'Paste':
    'Vložit',
  'You are looking at a shared image.':
    'Prohlížíte si sdílený obrázek.',
  'Back to my image':
    'Zpět k mému obrázku',
  'Place':
    'Umístit',
  'Paint':
    'Malování',
  'Outline':
    'Obrys',
  'From image':
    'Z obrázku',
  'Click a swatch = paint color · right-click = outline color · double-click = edit (also recolors the image). The ∅ swatch paints transparent. Palettes are shared with the vector app.':
    'Klik na vzorník = barva malování · pravý klik = barva obrysu · dvojklik = upravit (přebarví i obrázek). Vzorník ∅ maluje průhledně. Palety jsou společné s vektorovou aplikací.',
  'Brush':
    'Štětec',
  'Smooth edges for lines and polygons':
    'Hladké okraje čar a mnohoúhelníků',
  'The pencil always paints hard pixels in exact palette colors – best for pixel mosaics. Shift: straight lines in 15° steps.':
    'Tužka vždy kreslí ostré pixely v přesných barvách palety – nejlepší pro pixelové mozaiky. Shift: rovné čáry v krocích po 15°.',
  'Fill with the paint color':
    'Vyplnit barvou malování',
  'Outline in the outline color':
    'Obrys v barvě obrysu',
  'Drag from the center. Shift: 15° rotation steps.':
    'Táhněte ze středu. Shift: otáčení po 15°.',
  'Tolerance':
    'Tolerance',
  'Only connected pixels':
    'Jen souvislé pixely',
  'Fills the area of similar color under the click. Alt+click picks a color.':
    'Vyplní plochu podobné barvy pod kliknutím. Alt+klik vybere barvu.',
  'Cut':
    'Vyjmout',
  'Crop':
    'Oříznout',
  'Drag inside the selection to move it (Alt+drag moves a copy), a corner to scale it, the knob above it to turn it; two fingers on it scale and turn it. The bar below it turns, flips, duplicates and deletes. Enter places it, Esc cancels.':
    'Tažením uvnitř výběru ho posunete (Alt+tažení posune kopii), tažením za roh ho zvětšíte či zmenšíte, úchytem nad ním ho otočíte; dvěma prsty na něm ho zvětšíte, zmenšíte a otočíte. Lišta pod ním otáčí, překlápí, duplikuje a maže. Enter ho umístí, Esc zruší.',
  'Mosaic':
    'Mozaika',
  'Make a mosaic…':
    'Vytvořit mozaiku…',
  'Reduce to palette':
    'Převést na paletu',
  'Open as vector tiles…':
    'Otevřít jako vektorové dlaždice…',
  'Works on the selection, or on the whole image when nothing is selected.':
    'Pracuje s výběrem, nebo s celým obrázkem, když není nic vybráno.',
  'Image':
    'Obrázek',
  'Resize image':
    'Změnit velikost obrázku',
  'Canvas size':
    'Velikost plátna',
  'Pixel grid when zoomed in':
    'Mřížka pixelů při přiblížení',
  'Select, Brush, Pencil, Eraser, Line, Polygon, Ellipse, Curve, Bucket, Pick color, Pan':
    'Výběr, Štětec, Tužka, Guma, Čára, Mnohoúhelník, Elipsa, Křivka, Kbelík, Kapátko, Posun',
  'Smaller / bigger brush':
    'Menší / větší štětec',
  'Swap paint and outline colors':
    'Prohodit barvu malování a obrysu',
  'Alt+click':
    'Alt+klik',
  'Pick a color':
    'Vybrat barvu',
  'Straight lines, 15° steps':
    'Rovné čáry, kroky po 15°',
  'Copy, cut, paste images (also between the two apps and other programs)':
    'Kopírovat, vyjmout, vložit obrázky (i mezi oběma aplikacemi a jinými programy)',
  'Select all, clear the selection':
    'Vybrat vše, vymazat výběr',
  'Place / cancel a moved or pasted image':
    'Umístit / zrušit posunutý nebo vložený obrázek',
  'Fit image, actual pixels':
    'Celý obrázek, skutečné pixely',
  'Real width':
    'Skutečná šířka',
  'Pieces are areas of one color (tiles). “Replace with” recolors every pixel of that color.':
    'Dílky jsou plochy jedné barvy (dlaždice). „Nahradit za“ přebarví všechny pixely té barvy.',
  'The image is packed into the link itself – nothing is uploaded. Whoever opens it sees the image and can make their own copy to edit.':
    'Obrázek je zabalený přímo v odkazu – nic se nikam nenahrává. Kdo ho otevře, uvidí obrázek a může si udělat vlastní kopii k úpravám.',
  'Make a mosaic':
    'Vytvořit mozaiku',
  'Splits the picture into tiles and gives each tile the color underneath it, with grout between the tiles.':
    'Rozdělí obrázek na dlaždice, každé dá barvu, která je pod ní, a mezi dlaždice dá spáry.',
  'Squares':
    'Čtverce',
  'Squares, offset rows':
    'Čtverce, posunuté řady',
  'Bricks':
    'Cihly',
  'Hexagons':
    'Šestiúhelníky',
  'Irregular (crazy paving)':
    'Nepravidelné (mozaika z úlomků)',
  'Grout':
    'Spáry',
  'Smaller tiles where the picture has detail':
    'Menší dlaždice tam, kde má obrázek detaily',
  'colors from the picture (new palette)':
    'barev z obrázku (nová paleta)',
  'Keep the picture’s colors':
    'Zachovat barvy obrázku',
  'Open as vector tiles':
    'Otevřít jako vektorové dlaždice',
  'Every piece of the picture (an area of one color) becomes a tile shape in the vector app, at the real size – ready for its print templates, laying plan, 3D print and editing. Your current vector drawing is kept in its History.':
    'Každý dílek obrázku (plocha jedné barvy) se stane tvarem dlaždice ve vektorové aplikaci, ve skutečné velikosti – připravený pro tiskové šablony, plán pokládky, 3D tisk i úpravy. Vaše aktuální vektorová kresba zůstane v její Historii.',
  'The grout color becomes the page background; every other piece becomes a tile.':
    'Barva spár se stane pozadím stránky; každý další dílek se stane dlaždicí.',
  'Open in the vector app':
    'Otevřít ve vektorové aplikaci',
  'Format':
    'Formát',
  'JPEG':
    'JPEG',
  'WebP':
    'WebP',
  'Quality':
    'Kvalita',
  'JPEG has no transparency: transparent parts become white.':
    'JPEG nemá průhlednost: průhledná místa budou bílá.',
  'Simple shows the essentials; Expert adds opacity, tolerance, resizing and more':
    'Jednoduchý ukazuje to podstatné; Expert přidává krytí, toleranci, změnu velikosti a další',
  'New image':
    'Nový obrázek',
  'Open an image (Ctrl+O) – you can also drop one on the canvas':
    'Otevřít obrázek (Ctrl+O) – můžete ho také přetáhnout na plátno',
  'Save as PNG (Ctrl+S)':
    'Uložit jako PNG (Ctrl+S)',
  'Export as JPEG or WebP':
    'Exportovat jako JPEG nebo WebP',
  'Colors used, pieces and a shopping list':
    'Použité barvy, dílky a nákupní seznam',
  'Earlier versions of your image':
    'Starší verze vašeho obrázku',
  'Share the image as a link':
    'Sdílet obrázek jako odkaz',
  'Copy the selection (or the whole image) to the clipboard (Ctrl+C)':
    'Zkopírovat výběr (nebo celý obrázek) do schránky (Ctrl+C)',
  'Paste an image from the clipboard (Ctrl+V)':
    'Vložit obrázek ze schránky (Ctrl+V)',
  'Fit image (0)':
    'Celý obrázek (0)',
  'Actual pixels (1)':
    'Skutečné pixely (1)',
  'Select – drag a rectangle, then drag it to move (V)':
    'Výběr – táhněte obdélník a tažením ho posuňte (V)',
  'Brush – soft edges (B)':
    'Štětec – měkké okraje (B)',
  'Pencil – hard pixels in exact colors (P)':
    'Tužka – ostré pixely v přesných barvách (P)',
  'Eraser (E)':
    'Guma (E)',
  'Paint bucket – fill an area (F)':
    'Kbelík – vyplnit plochu (F)',
  'Pick a color (I, or Alt+click with any paint tool)':
    'Kapátko (I, nebo Alt+klik s jakýmkoli nástrojem malování)',
  'Your saved palettes (shared with the vector app)':
    'Vaše uložené palety (společné s vektorovou aplikací)',
  'Paint color – brush, pencil, lines, polygons and the bucket':
    'Barva malování – štětec, tužka, čáry, mnohoúhelníky a kbelík',
  'Outline color – the outline of polygons':
    'Barva obrysu – obrys mnohoúhelníků',
  'Swap paint and outline colors (X)':
    'Prohodit barvu malování a obrysu (X)',
  'Brush, pencil, eraser and line size in pixels ( [ and ] )':
    'Velikost štětce, tužky, gumy a čáry v pixelech ( [ a ] )',
  'Add the colors used in the image (or suggest some for a photo)':
    'Přidat barvy použité v obrázku (nebo u fotky nějaké navrhnout)',
  'Turn the image (or the selection) into tiles with grout':
    'Převést obrázek (nebo výběr) na dlaždice se spárami',
  'Give every pixel the closest palette color':
    'Dát každému pixelu nejbližší barvu z palety',
  'Every tile becomes a shape in the vector app – for its templates, laying plan and editing':
    'Každá dlaždice se stane tvarem ve vektorové aplikaci – pro její šablony, plán pokládky a úpravy',
  'Scale the picture to this size':
    'Zmenšit / zvětšit obrázek na tuto velikost',
  'Change the canvas size, keeping the picture centered':
    'Změnit velikost plátna, obrázek zůstane uprostřed',
  'The width of the finished mosaic':
    'Šířka hotové mozaiky',
  'Herringbone':
    'Rybí kost',
  'Triangles':
    'Trojúhelníky',
  'Rings (around the click)':
    'Kruhy (kolem kliknutí)',
  'Rows following the outline':
    'Řady podél obrysu',
  'portrait':
    'na výšku',
  'landscape':
    'na šířku',
  'Vector':
    'Vektor',
  'Raster':
    'Rastr',
  'Fit':
    'Vše',
  'Thinnest part':
    'Nejtenčí část',
  'Raised parts narrower than this – or more than twice as tall as they are wide – are lowered to what is around them, so nothing prints as a thin tower':
    'Vyvýšená místa užší než tato hodnota – nebo víc než dvakrát vyšší, než jsou široká – se sníží na úroveň okolí, aby se nic netisklo jako tenká věžička',
  'Grout colors are always printed first, so the lines between the tiles stay low.':
    'Barvy spár se tisknou vždy jako první, takže čáry mezi dlaždicemi zůstanou nízko.',
  'Grout / lines: always printed first, so they stay low':
    'Spáry / čáry: tisknou se vždy jako první, takže zůstanou nízko',
  'grout':
    'spáry',
  '{n} thin {n|piece|pieces} lowered so nothing prints as a thin tower':
    '{n} {n|tenký dílek snížen|tenké dílky sníženy|tenkých dílků sníženo}, aby se nic netisklo jako tenká věžička',
  'Top view':
    'Shora',
  'Drag to turn · wheel or two fingers to zoom · double-click to reset':
    'Tažením otáčíte · kolečkem nebo dvěma prsty přibližujete · dvojklik vrátí pohled',
  'Shows the heights taller than they are, to see the color bands':
    'Zobrazí výšky větší, než jsou, aby byly vidět barevné vrstvy',
  'Heights ×':
    'Výšky ×',
  'This browser can’t show 3D (WebGL is off).':
    'Tento prohlížeč neumí zobrazit 3D (WebGL je vypnuté).',
  'One nozzle – colors by height':
    'Jedna tryska – barvy podle výšky',
  'Several filaments (AMS, MMU…) – flat':
    'Více filamentů (AMS, MMU…) – plochý',
  'A flat model with one part per color, for printers that switch filaments by themselves. The 3MF file already assigns filament 1, 2, … to the parts – load the filaments in the order listed below.':
    'Plochý model s jedním dílem pro každou barvu, pro tiskárny, které samy mění filamenty. Soubor 3MF už dílům přiřazuje filament 1, 2, … – založte filamenty v pořadí uvedeném níže.',
  'How thick the tiles are above the base':
    'Jak silné jsou dlaždice nad podložkou',
  'Tile layers':
    'Vrstvy dlaždic',
  'Grout colors end this many layers below the tiles, so the lines between them stay low. 0: all flat':
    'Barvy spár končí o tolik vrstev níž než dlaždice, takže čáry mezi nimi zůstanou nízko. 0: vše rovně',
  'Grout lower by':
    'Spáry níž o',
  'layers':
    'vrstvy',
  'Filaments:':
    'Filamenty:',
  'Grout colors come first and stay lower than the tiles. The base plate uses filament 1.':
    'Barvy spár jsou první a zůstávají níž než dlaždice. Podložka se tiskne filamentem 1.',
  '3MF for':
    '3MF pro',
  'The model, one part per color with its filament':
    'Model, jeden díl pro každou barvu s jejím filamentem',
  'One STL file per color, in a ZIP – load them as parts of one object':
    'Jeden soubor STL pro každou barvu, v ZIPu – načtěte je jako díly jednoho objektu',
  '{share} % · filament {k}':
    '{share} % · filament {k}',
  '{n} {n|color|colors} = {n} {n|filament|filaments} · flat, {h} mm high ({layers} {layers|layer|layers})':
    '{n} {n|barva|barvy|barev} = {n} {n|filament|filamenty|filamentů} · plochý, výška {h} mm ({layers} {layers|vrstva|vrstvy|vrstev})',
  'Base':
    'Podložka',
  'Mosaic Paint – multi-filament plan for {name}.3mf':
    'Mosaic Paint – plán více filamentů pro {name}.3mf',
  'Size {w} × {h} mm · layer height {lh} mm · base {base} {base|layer|layers} · tiles {tile} {tile|layer|layers} · grout {recess} {recess|layer|layers} lower':
    'Velikost {w} × {h} mm · výška vrstvy {lh} mm · podložka {base} {base|vrstva|vrstvy|vrstev} · dlaždice {tile} {tile|vrstva|vrstvy|vrstev} · spáry o {recess} {recess|vrstvu|vrstvy|vrstev} níž',
  'Total height {total} mm.':
    'Celková výška {total} mm.',
  'Filament {k}: {color} (also the base plate)':
    'Filament {k}: {color} (i podložka)',
  'Filament {k}: {color}':
    'Filament {k}: {color}',
  '{slicer}: open the 3MF – every color is a part of one object with its filament already assigned. Load the filaments in this order (AMS slots, MMU…).':
    '{slicer}: otevřete 3MF – každá barva je díl jednoho objektu a má už přiřazený filament. Založte filamenty v tomto pořadí (sloty AMS, MMU…).',
  'The 3MF is made for {slicer}: other slicers may read it as one part – then use the STL files.':
    '3MF je určený pro {slicer}: jiné slicery ho mohou načíst jako jeden díl – pak použijte soubory STL.',
  'STL: one file per color in a ZIP. Load them together as one object made of parts and give each its filament.':
    'STL: jeden soubor pro každou barvu v ZIPu. Načtěte je společně jako jeden objekt z dílů a každému přiřaďte jeho filament.',
  'Saved {name}.3mf for {slicer}: {n} {n|part|parts} with their filaments assigned.':
    'Uloženo {name}.3mf pro {slicer}: {n} {n|díl|díly|dílů} s přiřazenými filamenty.',
  'Saved {name}-stl.zip: {n} STL {n|file|files}, one per color. Load them as parts of one object.':
    'Uloženo {name}-stl.zip: {n} {n|soubor|soubory|souborů} STL, jeden pro každou barvu. Načtěte je jako díly jednoho objektu.',
  'Finishing: frame, corners, hanging hole, magnets':
    'Dokončení: rámeček, rohy, otvor na pověšení, magnety',
  'A border around the picture. With one nozzle it comes out in the top color, with several filaments in filament 1. 0: none':
    'Okraj kolem obrázku. S jednou tryskou vyjde v horní barvě, s více filamenty ve filamentu 1. 0: žádný',
  'Frame':
    'Rámeček',
  'How many layers the frame stands above the tiles':
    'O kolik vrstev rámeček přečnívá nad dlaždice',
  'raised by':
    'vyšší o',
  'Radius of the outline’s corners. 0: square':
    'Poloměr rohů obrysu. 0: ostré rohy',
  'Rounded corners':
    'Zaoblené rohy',
  'A hole to hang it by, at the top in the middle. 0: none':
    'Otvor na pověšení, nahoře uprostřed. 0: žádný',
  'Hanging hole':
    'Otvor na pověšení',
  'Four round pockets in the bottom, one near each corner, to glue magnets in: their diameter. 0: none':
    'Čtyři kruhové kapsy ve spodku, u každého rohu jedna, pro vlepení magnetů: jejich průměr. 0: žádné',
  'Magnets':
    'Magnety',
  'How deep the magnet pockets are (the magnet’s thickness)':
    'Jak hluboké jsou kapsy pro magnety (tloušťka magnetu)',
  'deep':
    'hloubka',
  'with the frame {w} × {h} mm, {z} mm high':
    's rámečkem {w} × {h} mm, výška {z} mm',
  'The model is too thin for magnet pockets.':
    'Model je na kapsy pro magnety příliš tenký.',
  'The magnet pockets are only {d} mm deep – the model is thinner there.':
    'Kapsy pro magnety jsou hluboké jen {d} mm – model je tam tenčí.',
  'Frame {w} mm wide, up to layer {layer} (Z {z} mm), in filament 1.':
    'Rámeček široký {w} mm, až do vrstvy {layer} (Z {z} mm), filamentem 1.',
  'Frame {w} mm wide: it goes on in {color} up to layer {layer} (Z {z} mm).':
    'Rámeček široký {w} mm: pokračuje barvou {color} až do vrstvy {layer} (Z {z} mm).',
  'Magnet pockets in the bottom: 4 × {d} mm, {depth} mm deep – glue the magnets in after printing.':
    'Kapsy pro magnety ve spodku: 4 × {d} mm, hloubka {depth} mm – magnety vlepte po vytištění.',
  'Making the mosaic…':
    'Vytvářím mozaiku…',
  'Could not make the mosaic.':
    'Mozaiku se nepodařilo vytvořit.',
  'Tracing the tiles…':
    'Obkresluji dlaždice…',
  'Could not trace the tiles.':
    'Dlaždice se nepodařilo obkreslit.',
  'Working out the model…':
    'Počítám model…',
  'Working out the model… {p} %':
    'Počítám model… {p} %',
  'Could not build the 3D model.':
    '3D model se nepodařilo vytvořit.',
  'Building the 3D model…':
    'Vytvářím 3D model…',
  'Building the 3D model… {p} %':
    'Vytvářím 3D model… {p} %',
  'Coaster':
    'Podtácek',
  'HOME':
    'DOMOV',
  'Sign':
    'Cedulka',
  '100 × 100 mm, square tiles in rings of color – try 3D… with rounded corners.':
    '100 × 100 mm, čtvercové dlaždice v barevných prstencích – zkuste 3D… se zaoblenými rohy.',
  'coaster':
    'podtacek',
  'A word in tiles with a border – try Report for a shopping list.':
    'Slovo z dlaždic s okrajem – v Přehledu najdete nákupní seznam.',
  'sign':
    'cedulka',
  'Welcome to Mosaic Paint':
    'Vítejte v Mosaic Paint',
  'Design a mosaic: draw lines or lay a tile pattern, then paint the tiles. Everything is measured in real millimetres.':
    'Navrhněte mozaiku: nakreslete čáry nebo položte vzor dlaždic a pak dlaždice vybarvěte. Vše se měří ve skutečných milimetrech.',
  'Draw':
    'Kreslení',
  'The tools are on the left: lines and shapes, the tile pattern, and the paint bucket that fills a tile with one click.':
    'Nástroje jsou vlevo: čáry a tvary, vzor dlaždic a kbelík, který jedním kliknutím vybarví dlaždici.',
  'Pick a color in the palette, then click tiles with the bucket. Palettes are shared with the raster app.':
    'Vyberte barvu v paletě a klikejte kbelíkem na dlaždice. Palety jsou společné s rastrovou aplikací.',
  'When it is done':
    'Až bude hotovo',
  'Report gives a shopping list, 3D… a model to print, Share a link. Expert mode adds printing at real size and laying plans.':
    'Přehled dá nákupní seznam, 3D… model k tisku, Sdílet odkaz. Režim Expert přidá tisk ve skutečné velikosti a plány kladení.',
  'Start from an example':
    'Začněte od příkladu',
  'Not sure where to begin? Open an example. The ? button shows this guide again.':
    'Nevíte, kde začít? Otevřete příklad. Tlačítko ? ukáže tohoto průvodce znovu.',
  'Pixel heart':
    'Pixelové srdce',
  '16 × 16 pixel art – every pixel a tile. Try 3D… or Print.':
    'Pixel art 16 × 16 – každý pixel je dlaždice. Zkuste 3D… nebo Tisk.',
  'heart':
    'srdce',
  'Heart':
    'Srdce',
  'Sunset mosaic':
    'Mozaika se západem slunce',
  'A picture made into tiles with grout by “Make a mosaic…”. Try Open as vector tiles.':
    'Obrázek proměněný v dlaždice se spárami pomocí „Vytvořit mozaiku…“. Zkuste Otevřít jako vektorové dlaždice.',
  'sunset':
    'zapad-slunce',
  'Sunset':
    'Západ slunce',
  'Welcome to Mosaic Paint Raster':
    'Vítejte v Mosaic Paint Raster',
  'Paint with pixels: pixel art, or a photo turned into a mosaic. Each pixel can become a tile.':
    'Malujte pixely: pixel art nebo fotku proměněnou v mozaiku. Každý pixel se může stát dlaždicí.',
  'The tools are on the left: pencil, brush, bucket, lines, shapes and selection.':
    'Nástroje jsou vlevo: tužka, štětec, kbelík, čáry, tvary a výběr.',
  'Pick a color in the palette. Palettes are shared with the vector app.':
    'Vyberte barvu v paletě. Palety jsou společné s vektorovou aplikací.',
  'Open a photo, then “Make a mosaic…” turns it into tiles with grout in your palette’s colors.':
    'Otevřete fotku a „Vytvořit mozaiku…“ z ní udělá dlaždice se spárami v barvách vaší palety.',
  'Examples':
    'Příklady',
  'Open an example to see how it is made, or to start from it. Your current work is kept in History.':
    'Otevřete příklad a podívejte se, jak je udělaný, nebo z něj vyjděte. Vaše současná práce zůstane v Historii.',
  'Back':
    'Zpět',
  '{k} of {n}':
    '{k} z {n}',
  'Next':
    'Další',
  'Examples…':
    'Příklady…',
  'Example projects to open':
    'Ukázkové projekty k otevření',
  'A short guide to the app':
    'Krátký průvodce aplikací',
  'Guide':
    'Průvodce',
  'Working… {p} %':
    'Pracuji… {p} %',
  'Your photo':
    'Vaše fotka',
  'Load a photo and turn it into tiles – smaller where it has detail.':
    'Načtěte fotku a proměňte ji v dlaždice – menší tam, kde má detaily.',
  'Read the G-code your slicer made and check it against this plan: filament changes, filaments and heights':
    'Načte G-code ze sliceru a porovná ho s tímto plánem: výměny filamentu, filamenty a výšky',
  'Check G-code…':
    'Zkontrolovat G-code…',
  'Change to {color} at Z {z} mm':
    'Výměna na {color} v Z {z} mm',
  'No filament change to {color} at Z {z} mm':
    'Chybí výměna filamentu na {color} v Z {z} mm',
  'A filament change the plan does not have, at Z {z} mm':
    'Výměna filamentu, kterou plán nemá, v Z {z} mm',
  'The top is at {z} mm, as planned':
    'Vršek je ve výšce {z} mm, podle plánu',
  'The top is at {found} mm instead of {z} mm':
    'Vršek je ve výšce {found} mm místo {z} mm',
  'Filament {k} ({color}) is not used – assign it to the part “{k} {color}”':
    'Filament {k} ({color}) se nepoužívá – přiřaďte ho dílu „{k} {color}“',
  'Filament {k} ({color}) prints up to {z} mm':
    'Filament {k} ({color}) tiskne do výšky {z} mm',
  'Filament {k} ({color}) prints up to {found} mm instead of {z} mm':
    'Filament {k} ({color}) tiskne do výšky {found} mm místo {z} mm',
  'No printing found in {name} – is it a G-code file?':
    'V {name} není žádný tisk – je to soubor G-code?',
  '{name}: {n} {n|thing|things} to look at':
    '{name}: {n} {n|věc|věci|věcí} ke kontrole',
  '{name}: everything matches the plan':
    '{name}: vše odpovídá plánu',
  'Reading the G-code…':
    'Čtu G-code…',
  'Reading the G-code… {p} %':
    'Čtu G-code… {p} %',
  'Could not read {name}.':
    '{name} se nepodařilo přečíst.',
  '{name} is {w} × {h} px – painting on it and making mosaics will be slow. Scale it down to {W} × {H} px?':
    '{name} má {w} × {h} px – malování a mozaiky na něm budou pomalé. Zmenšit ho na {W} × {H} px?',
  'It has many colors: “Reduce to palette” or “Make a mosaic…” turn them into a few you can buy tiles in.':
    'Má mnoho barev: „Převést na paletu“ nebo „Vytvořit mozaiku…“ z nich udělá pár barev, ve kterých dlaždice koupíte.',
  '{n} {n|color|colors}':
    '{n} {n|barva|barvy|barev}',
  'Unpin – it may be cleared with old versions':
    'Odepnout – může být smazána se starými verzemi',
  'Pin – kept when old versions are cleared':
    'Připnout – zůstane, i když se staré verze mažou',
  'Name this version':
    'Pojmenovat tuto verzi',
  'Name of this version:':
    'Název této verze:',
  'Share link':
    'Odkaz ke sdílení',
  'What’s new':
    'Co je nového',
  'Version {v} – what’s new':
    'Verze {v} – co je nového',
  'Updated to version {v} – click v{v} in the corner to see what’s new.':
    'Aktualizováno na verzi {v} – co je nového, uvidíte po kliknutí na v{v} v rohu.',
  'The raster app: paint with pixels, turn photos into mosaics, and copy pictures between both apps.':
    'Rastrová aplikace: malování pixely, fotky proměněné v mozaiky a kopírování obrázků mezi oběma aplikacemi.',
  '3D print: a 3D preview, models for multi-filament printers (AMS, MMU), a frame, rounded corners, a hanging hole and magnet pockets – and a check of the sliced G-code against the plan.':
    '3D tisk: 3D náhled, modely pro tiskárny s více filamenty (AMS, MMU), rámeček, zaoblené rohy, otvor na pověšení a kapsy na magnety – a kontrola G-codu ze sliceru podle plánu.',
  'Examples to start from, and a short guide for newcomers.':
    'Příklady, od kterých můžete začít, a krátký průvodce pro nováčky.',
  'German, Slovak and Polish.':
    'Němčina, slovenština a polština.',
  'Heavy work – mosaics, tracing, 3D models – no longer holds up the page.':
    'Náročná práce – mozaiky, obkreslování, 3D modely – už stránku nezdržuje.',
  'History: name and pin versions; see their size and colors.':
    'Historie: verze můžete pojmenovat a připnout; vidíte jejich velikost a barvy.',
  'Big images can be scaled down when opened.':
    'Velké obrázky lze při otevření zmenšit.',
  'Better keyboard and screen-reader support.':
    'Lepší podpora klávesnice a čteček obrazovky.',
  'The vector editor: lines, tile patterns, the paint bucket, palettes, reports, printing at real size and sharing as a link.':
    'Vektorový editor: čáry, vzory dlaždic, kbelík, palety, přehledy, tisk ve skutečné velikosti a sdílení odkazem.',
  'Could not sign in to Discord.':
    'Přihlášení k Discordu se nezdařilo.',
  'Post to the channel':
    'Poslat do kanálu',
  'Post the picture in this channel, as a reply to the message it came from':
    'Poslat obrázek do tohoto kanálu jako odpověď na zprávu, ze které pochází',
  'That image is no longer available in Discord.':
    'Ten obrázek už na Discordu není k dispozici.',
  'Right-click an image in the chat › Apps › Edit image to edit it here – or open or paste one.':
    'Klikněte pravým tlačítkem na obrázek v chatu › Aplikace › Edit image a upravte ho tady – nebo nějaký otevřete či vložte.',
  'Posted to the channel.':
    'Posláno do kanálu.',
  'The picture is too big for Discord – make it smaller (Image › Resize image).':
    'Obrázek je pro Discord příliš velký – zmenšete ho (Obrázek › Změnit velikost obrázku).',
  'Could not reach the server.':
    'Server není dostupný.',
  'Could not connect to Discord.':
    'Spojení s Discordem se nezdařilo.',
  'Open the editor with “Edit image” (or the app’s launch button) in this chat to post here – or use Copy and paste the picture.':
    'Otevřete editor přes „Edit image“ (nebo tlačítko aplikace pro spuštění) v tomto chatu, abyste sem mohli poslat obrázek – nebo použijte Kopírovat a obrázek vložte.',
  'More than 15 minutes have passed, and Discord no longer lets the app post. Use Copy and paste the picture into the chat.':
    'Uplynulo víc než 15 minut a Discord už aplikaci poslat obrázek nedovolí. Použijte Kopírovat a obrázek vložte do chatu.',
  'Discord did not take the picture. Use Copy and paste it into the chat.':
    'Discord obrázek nepřijal. Použijte Kopírovat a vložte ho do chatu.',
  'Select the part to keep with the Select tool (V), then crop.':
    'Nástrojem Výběr (V) vyberte část, kterou chcete ponechat, a pak ořízněte.',
  'The image is all one color – nothing to trim.':
    'Obrázek je celý jedné barvy – není co ořezávat.',
  'There is no border to trim.':
    'Není tu žádný okraj k oříznutí.',
  'Trimmed to {w} × {h} px.':
    'Oříznuto na {w} × {h} px.',
  'Pen pressure changes the size':
    'Přítlak pera mění velikost',
  'Tip':
    'Hrot',
  'Round':
    'Kulatý',
  'Soft (airbrush)':
    'Měkký (airbrush)',
  'Spray':
    'Sprej',
  'Calligraphy':
    'Kaligrafie',
  'Chalk':
    'Křída',
  'The shape of the brush and eraser':
    'Tvar štětce a gumy',
  'The angle of the calligraphy nib – 45° for right-handed writing, about 135° for left-handed':
    'Úhel kaligrafického hrotu – 45° pro praváky, asi 135° pro leváky',
  'curve through points':
    'křivka přes body',
  'B-spline':
    'B-spline',
  'cubic Bézier':
    'kubická Bézierova křivka',
  'quadratic Bézier':
    'kvadratická Bézierova křivka',
  'ellipse':
    'elipsa',
  'Drag from corner to corner (or from the center) · Shift: a circle · Alt: no snap':
    'Táhněte z rohu do rohu (nebo ze středu) · Shift: kruh · Alt: bez přichytávání',
  'Click the curve’s points · click the first point to close it · double-click or Enter ends it open · Backspace removes the last point · Esc cancels':
    'Klikejte na body křivky · kliknutím na první bod ji uzavřete · dvojklik nebo Enter ji ukončí otevřenou · Backspace odebere poslední bod · Esc zruší',
  'Turn on “Fill” or “Outline” for shapes.':
    'U tvarů zapněte „Výplň“ nebo „Obrys“.',
  'Drag from corner to corner (or from the center) · Shift: a circle':
    'Táhněte z rohu do rohu (nebo ze středu) · Shift: kruh',
  'The curve runs smoothly through every point you click.':
    'Křivka vede plynule přes každý bod, na který kliknete.',
  'The curve is pulled towards each point but only touches the first and the last – very smooth, good for flowing lines.':
    'Křivku každý bod přitahuje, ale dotkne se jen prvního a posledního – velmi hladká, vhodná pro plynulé linie.',
  'Click a point, two control points, the next point, two control points … The curve passes through every third point; the control points (round) pull it.':
    'Klikněte na bod, dva řídicí body, další bod, dva řídicí body … Křivka prochází každým třetím bodem; řídicí body (kulaté) ji přitahují.',
  'Click a point, a control point, the next point, a control point … The curve passes through every other point; the control points (round) pull it.':
    'Klikněte na bod, řídicí bod, další bod, řídicí bod … Křivka prochází každým druhým bodem; řídicí body (kulaté) ji přitahují.',
  'Ellipse':
    'Elipsa',
  'From corner':
    'Z rohu',
  'Shift: a circle. Select it to drag its axis ends.':
    'Shift: kruh. Po výběru můžete táhnout konce jejích os.',
  'Curve':
    'Křivka',
  'Type':
    'Typ',
  'Smooth, through the points':
    'Hladká, přes body',
  'Smooth, near the points (B-spline)':
    'Hladká, u bodů (B-spline)',
  'Bézier, cubic':
    'Bézierova, kubická',
  'Bézier, quadratic':
    'Bézierova, kvadratická',
  'Ellipse – Shift: circle (O)':
    'Elipsa – Shift: kruh (O)',
  'Curve – click its points (C)':
    'Křivka – klikejte na její body (C)',
  'Shift: a circle.':
    'Shift: kruh.',
  'An open curve is a line in the paint color, as thick as the size; a closed one is filled and outlined like the shapes.':
    'Otevřená křivka je čára v barvě malování o zvolené velikosti; uzavřená se vyplní a obtáhne jako tvary.',
  'Ellipses and curves in both apps: the Ellipse tool (O, Shift for a circle) and the Curve tool (C) – smooth through the points, smooth near them (B-spline), or cubic and quadratic Bézier.':
    'Elipsy a křivky v obou aplikacích: nástroj Elipsa (O, se Shiftem kruh) a nástroj Křivka (C) – hladká přes body, hladká u bodů (B-spline), nebo kubická a kvadratická Bézierova.',
  'In the vector app, ellipses and curves stay exact curves: drag their points or axis ends to change them, and paint, cut and mirror them like any tile.':
    'Ve vektorové aplikaci zůstávají elipsy a křivky přesnými křivkami: tažením bodů nebo konců os je měníte a vybarvujete, řežete a zrcadlíte je jako každou dlaždici.',
  'Shift+B':
    'Shift+B',
  'Next brush tip':
    'Další hrot štětce',
  'Brush tip: {tip}':
    'Hrot štětce: {tip}',
  'Brush tips for the brush and the eraser: soft (airbrush), spray, calligraphy and chalk. Shift+B switches between them.':
    'Hroty pro štětec a gumu: měkký (airbrush), sprej, kaligrafie a křída. Shift+B mezi nimi přepíná.',
  'The spray keeps spraying while you hold it still, like an airbrush; the calligraphy nib’s angle can be set (also for left-handed writing).':
    'Sprej stříká dál, i když ho držíte na místě, jako airbrush; úhel kaligrafického hrotu lze nastavit (i pro leváky).',
  'Keep proportions':
    'Zachovat poměr stran',
  'Flip ↔':
    'Převrátit ↔',
  'Flip ↕':
    'Převrátit ↕',
  'Rotate by':
    'Otočit o',
  'Rotate':
    'Otočit',
  'Crop to selection':
    'Oříznout na výběr',
  'Trim edges':
    'Oříznout okraje',
  'With a graphics tablet or stylus, the brush, pencil and eraser paint thinner the lighter you press':
    'S grafickým tabletem nebo perem kreslí štětec, tužka a guma tím tenčeji, čím lehčeji přitlačíte',
  'Rotate 90° to the left':
    'Otočit o 90° doleva',
  'Rotate 90° to the right':
    'Otočit o 90° doprava',
  'Flip left ↔ right':
    'Převrátit zleva doprava',
  'Flip upside down':
    'Převrátit vzhůru nohama',
  'Rotate by any angle (clockwise; negative: to the left) – the canvas grows to hold the picture':
    'Otočit o libovolný úhel (po směru hodin; záporný: doleva) – plátno se zvětší, aby se obrázek vešel',
  'Keep only the selection (select it with the Select tool first)':
    'Ponechat jen výběr (nejdřív ho vyberte nástrojem Výběr)',
  'Cut off the empty or one-color border around the picture':
    'Odříznout prázdný nebo jednobarevný okraj kolem obrázku',
  'Edit images from a Discord chat: right-click › Apps › Edit image, draw on it, post it back – in the raster or the vector app.':
    'Úpravy obrázků z chatu na Discordu: pravé tlačítko › Aplikace › Edit image, kreslete do něj a pošlete ho zpět – v rastrové i vektorové aplikaci.',
  'Pen pressure: with a graphics tablet or stylus, the brush, pencil and eraser paint thinner the lighter you press.':
    'Přítlak pera: s grafickým tabletem nebo perem kreslí štětec, tužka a guma tím tenčeji, čím lehčeji přitlačíte.',
  'Image editing in the raster app: rotate (by 90° or any angle), flip, crop to the selection, trim the border, resize keeping proportions.':
    'Úpravy obrázku v rastrové aplikaci: otočení (o 90° nebo o libovolný úhel), převrácení, oříznutí na výběr, oříznutí okrajů a změna velikosti se zachováním poměru stran.',
  'Choose a color':
    'Vyberte barvu',
  'Saturation and brightness':
    'Sytost a jas',
  'Hue':
    'Odstín',
  'Before':
    'Předtím',
  'Color code':
    'Kód barvy',
  'Also add it to the palette':
    'Přidat ji i do palety',
  'Use this color':
    'Použít tuto barvu',
  'Choose…':
    'Vybrat…',
  'Choose any color: a color area, a hue slider and a color code':
    'Vyberte libovolnou barvu: barevná plocha, posuvník odstínu a kód barvy',
  'Fill color – used by the paint bucket. Click to choose any color':
    'Barva výplně – používá ji kyblík. Kliknutím vyberete libovolnou barvu',
  'Stroke color – used for new lines and polygons. Click to choose any color':
    'Barva čáry – pro nové čáry a mnohoúhelníky. Kliknutím vyberete libovolnou barvu',
  'Paint color – brush, pencil, lines, polygons and the bucket. Click to choose any color':
    'Barva malby – štětec, tužka, čáry, mnohoúhelníky a kyblík. Kliknutím vyberete libovolnou barvu',
  'Outline color – the outline of polygons. Click to choose any color':
    'Barva obrysu – obrys mnohoúhelníků. Kliknutím vyberete libovolnou barvu',
  'Choose any color: a color area, a hue slider and a color code (Choose… under the palette, or click the current colors).':
    'Vyberte libovolnou barvu: barevná plocha, posuvník odstínu a kód barvy (Vybrat… pod paletou, nebo klikněte na aktuální barvy).',
  'Inside Discord: New, Save as, renaming and the other questions work (they are asked in the page now), and switching between the apps keeps the Post button.':
    'V Discordu: Nový, Uložit jako, přejmenování a další otázky fungují (ptají se teď přímo na stránce) a přepínání mezi aplikacemi zachová tlačítko pro odeslání.',
  'On phones inside Discord, the top bar stays clear of Discord’s own controls.':
    'Na telefonech v Discordu horní lišta nezasahuje pod ovládací prvky Discordu.',
  'Quick menu':
    'Rychlá nabídka',
  'Undo':
    'Zpět',
  'Redo':
    'Znovu',
  'Fit to the screen':
    'Přizpůsobit obrazovce',
  'Which color':
    'Která barva',
  'Choose any color':
    'Vybrat libovolnou barvu',
  'The palette is empty – use + to choose a color.':
    'Paleta je prázdná – barvu vyberete tlačítkem +.',
  'Tip: double-tap the drawing for a quick menu – tools, colors and size.':
    'Tip: dvojitým klepnutím na kresbu otevřete rychlou nabídku – nástroje, barvy a velikost.',
  'Quick menu on phones and tablets: double-tap the drawing with a finger for undo, the main tools, colors and size – right where you draw.':
    'Rychlá nabídka na telefonech a tabletech: dvojitým klepnutím prstem na kresbu máte po ruce zpět, hlavní nástroje, barvy a velikost – přímo tam, kde kreslíte.',
  'Tap or click where to copy from.':
    'Klepněte nebo klikněte tam, odkud kopírovat.',
  'Tap the image where to copy from':
    'Klepněte do obrázku tam, odkud kopírovat',
  'Copying from {x}, {y}':
    'Kopíruje se z {x}, {y}',
  'No source yet: the first tap sets it':
    'Zdroj zatím není: nastaví ho první klepnutí',
  'Source set – now paint where the copy goes.':
    'Zdroj nastaven – teď malujte tam, kam patří kopie.',
  'Clone':
    'Klonování',
  'Set source':
    'Nastavit zdroj',
  'Aligned – the source follows the brush':
    'Zarovnaně – zdroj se posouvá se štětcem',
  'Set where to copy from, then paint where the copy should go. Drag the source disc to move it. Size, tip and opacity are the brush\'s.':
    'Nastavte, odkud kopírovat, a pak malujte tam, kam má kopie přijít. Kotouček zdroje přesunete tažením. Velikost, hrot a krytí jsou jako u štětce.',
  'Clone – paint with a copy of another part of the image · Alt+click or the first tap sets where to copy from (S)':
    'Klonování – malujte kopií jiné části obrázku · Alt+klik nebo první klepnutí nastaví, odkud kopírovat (S)',
  'The next tap or click sets where to copy from (or Alt+click)':
    'Další klepnutí nebo kliknutí nastaví, odkud kopírovat (nebo Alt+klik)',
  'On: the source moves along with the brush from stroke to stroke. Off: every stroke starts copying from the source':
    'Zapnuto: zdroj se posouvá se štětcem od tahu k tahu. Vypnuto: každý tah začne kopírovat ze zdroje',
  'Clone tool in the raster app (S): paint with a copy of another part of the image. Tap (or Alt+click) where to copy from, paint the copy, drag the source disc with a finger to move it; aligned or not, with the brush’s size, tip, opacity and pen pressure.':
    'Nástroj Klonování v rastrové aplikaci (S): malujte kopií jiné části obrázku. Klepněte (nebo Alt+klik) tam, odkud kopírovat, namalujte kopii, kotouček zdroje posunete prstem; zarovnaně i ne, s velikostí, hrotem, krytím a přítlakem pera jako u štětce.',
  'Adjust colors':
    'Úprava barev',
  'Stretch the picture’s tones to the full range':
    'Roztáhnout tóny obrázku na celý rozsah',
  'Auto':
    'Automaticky',
  'Reset':
    'Vrátit',
  'Hold to see the picture as it was':
    'Podržte pro zobrazení původního obrázku',
  'Colors adjusted.':
    'Barvy upraveny.',
  'Heal':
    'Retuš',
  'Adjust colors…':
    'Upravit barvy…',
  'Select, Brush, Pencil, Eraser, Clone, Heal, Line, Polygon, Ellipse, Curve, Bucket, Pick color, Pan':
    'Výběr, Štětec, Tužka, Guma, Klonování, Retuš, Čára, Mnohoúhelník, Elipsa, Křivka, Kyblík, Kapátko, Posun',
  'Heal – like Clone, but the copy takes the color and light of the place you paint: for blemishes, spots and scratches (J)':
    'Retuš – jako Klonování, ale kopie převezme barvu a světlo místa, kam malujete: na skvrny, tečky a škrábance (J)',
  'Brightness, contrast, saturation, levels, sharpening and noise smoothing – for the selection or the whole image':
    'Jas, kontrast, sytost, úrovně, doostření a vyhlazení šumu – pro výběr nebo celý obrázek',
  'Photo fixes in the raster app: Adjust colors… – brightness, contrast, saturation, levels with Auto, sharpening and noise smoothing, previewed live (hold Before to compare).':
    'Úpravy fotek v rastrové aplikaci: Upravit barvy… – jas, kontrast, sytost, úrovně s tlačítkem Automaticky, doostření a vyhlazení šumu, s živým náhledem (podržením Předtím porovnáte).',
  'Heal brush (J): paints over blemishes, spots and scratches with texture from elsewhere, in the color and light of the spot.':
    'Retušovací štětec (J): přemaluje skvrny, tečky a škrábance texturou odjinud, v barvě a světle daného místa.',
  'Filling from the surroundings…':
    'Vyplňuje se z okolí…',
  'Removed.':
    'Odstraněno.',
  'Could not fill it: {why}':
    'Nepodařilo se vyplnit: {why}',
  'Select what to remove first.':
    'Nejdřív vyberte, co odstranit.',
  'Select':
    'Výběr',
  'Rectangle':
    'Obdélník',
  'Lasso':
    'Laso',
  'Magnetic':
    'Magnetické',
  'Wand':
    'Hůlka',
  'Add':
    'Přidat',
  'Subtract':
    'Ubrat',
  'Drag inside the selection to move it. Copy, Clear, Fill from surroundings and Adjust colors follow its shape.':
    'Tažením uvnitř výběru ho přesunete. Kopírovat, Vymazat, Vyplnit z okolí a Upravit barvy respektují jeho tvar.',
  'Paint over what should disappear; when you lift, it is filled from the picture around it. Works best on backgrounds – grass, sky, walls, skin.':
    'Přemalujte, co má zmizet; po zvednutí se to vyplní z okolního obrázku. Nejlépe funguje na pozadí – tráva, nebe, zdi, kůže.',
  'Fill with':
    'Vyplnit pomocí',
  'Surroundings (built in)':
    'Okolí (vestavěné)',
  'AI (add-on)':
    'AI (doplněk)',
  'Fill from surroundings':
    'Vyplnit z okolí',
  'Select, Brush, Pencil, Eraser, Clone, Heal, Remove, Line, Polygon, Ellipse, Curve, Bucket, Pick color, Pan':
    'Výběr, Štětec, Tužka, Guma, Klonování, Retuš, Odstranit, Čára, Mnohoúhelník, Elipsa, Křivka, Kyblík, Kapátko, Posun',
  'Shift / Alt + select':
    'Shift / Alt + výběr',
  'Add to / take away from the selection':
    'Přidat k výběru / ubrat z výběru',
  'Remove – paint over something to make it disappear: it is filled from the picture around it (R)':
    'Odstranit – přemalujte něco, aby to zmizelo: vyplní se to z okolního obrázku (R)',
  'Shape':
    'Tvar',
  'A rectangle: drag across':
    'Obdélník: táhněte přes',
  'Freehand: draw around it':
    'Od ruky: obkreslete to',
  'Draw roughly along an edge – the line snaps to it':
    'Kreslete zhruba podél hrany – čára se k ní přichytí',
  'Tap a color: everything similar next to it (or anywhere)':
    'Klepněte na barvu: vše podobné vedle ní (nebo kdekoli)',
  'New selection':
    'Nový výběr',
  'Replace the selection':
    'Nahradit výběr',
  'Add to the selection (or hold Shift)':
    'Přidat k výběru (nebo držte Shift)',
  'Take away from the selection (or hold Alt)':
    'Ubrat z výběru (nebo držte Alt)',
  'The selected part disappears: filled from the picture around it':
    'Vybraná část zmizí: vyplní se z okolního obrázku',
  'Shaped selections: Lasso, Magnetic (snaps to edges) and Wand (by color), with New / Add / Subtract (or Shift / Alt) – copy, clear, move and Adjust colors follow the shape.':
    'Výběry libovolného tvaru: Laso, Magnetické (přichytí se k hranám) a Hůlka (podle barvy), s Nový / Přidat / Ubrat (nebo Shift / Alt) – kopírování, mazání, přesun i Upravit barvy respektují tvar.',
  'Removing things: the Remove brush (R) and Fill from surroundings for a selection fill the spot with the picture around it – content-aware, on the device.':
    'Odstraňování: štětec Odstranit (R) a Vyplnit z okolí pro výběr vyplní místo okolním obrázkem – s ohledem na obsah, přímo v zařízení.',
  'Text':
    'Text',
  'Type here':
    'Pište sem',
  'Font':
    'Písmo',
  'List the fonts installed on this computer (the browser asks first)':
    'Zobrazit písma nainstalovaná v tomto počítači (prohlížeč se nejdřív zeptá)',
  'More fonts…':
    'Další písma…',
  'Style':
    'Řez',
  'Bold':
    'Tučně',
  'Italic':
    'Kurzíva',
  'Alignment':
    'Zarovnání',
  'Left':
    'Vlevo',
  'Center':
    'Na střed',
  'Right':
    'Vpravo',
  'Shadow':
    'Stín',
  'The text is in the paint color, its outline in the outline color. Drag it into place, then press Enter or tap outside it.':
    'Text má barvu malby, obrys barvu obrysu. Přetáhněte ho na místo a pak stiskněte Enter nebo klepněte mimo něj.',
  '{n} fonts listed.':
    'Zobrazeno písem: {n}.',
  'The browser did not list the fonts.':
    'Prohlížeč písma nezobrazil.',
  'Drag the text into place, then press Enter or tap outside it.':
    'Přetáhněte text na místo a pak stiskněte Enter nebo klepněte mimo něj.',
  'Tap where to copy from (or Alt+click), then paint the copy · drag the source disc to move it':
    'Klepněte, odkud kopírovat (nebo Alt+klik), pak malujte kopii · kotouček zdroje posunete tažením',
  'Tap where to copy from (or Alt+click), then paint over the spot – it blends in when you lift':
    'Klepněte, odkud kopírovat (nebo Alt+klik), pak přemalujte místo – po zvednutí splyne',
  'Paint over what should disappear – it is filled from the surroundings when you lift':
    'Přemalujte, co má zmizet – po zvednutí se vyplní z okolí',
  'Tap to add text · drag it into place · tap it to edit · Enter places it':
    'Klepnutím přidáte text · přetáhněte ho na místo · klepnutím ho upravíte · Enter ho umístí',
  'Select, Brush, Pencil, Eraser, Clone, Heal, Remove, Blur, Noise, Twist, Text, Line, Polygon, Ellipse, Curve, Bucket, Pick color, Pan':
    'Výběr, Štětec, Tužka, Guma, Klonování, Retuš, Odstranit, Rozmazání, Šum, Zkroucení, Text, Čára, Mnohoúhelník, Elipsa, Křivka, Kyblík, Kapátko, Posun',
  'Text – tap to type; fonts, outline, shadow and curved text (T)':
    'Text – klepněte a pište; písma, obrys, stín a zakřivený text (T)',
  'Text tool in the raster app (T): any font (also the installed ones, where the browser lists them), size, bold, italic, alignment, outline, shadow and curved text. It floats until placed – drag it, tap it to edit.':
    'Nástroj Text v rastrové aplikaci (T): libovolné písmo (i nainstalovaná, kde je prohlížeč umí zobrazit), velikost, tučné, kurzíva, zarovnání, obrys, stín a zakřivený text. Do umístění plave nad obrázkem – přetáhněte ho, klepnutím upravíte.',
  'The AI could not start in this browser.':
    'AI se v tomto prohlížeči nepodařilo spustit.',
  'Starting the AI…':
    'Spouští se AI…',
  'The AI could not do it: {why}':
    'AI to nezvládla: {why}',
  'Looking at the picture…':
    'Prohlíží se obrázek…',
  'Nothing found there – tap the middle of the object.':
    'Nic se tam nenašlo – klepněte doprostřed objektu.',
  'the AI add-on is not downloaded':
    'doplněk AI není stažený',
  'Remove background':
    'Odstranit pozadí',
  'What is in the picture?':
    'Co je na obrázku?',
  'People (portraits)':
    'Lidé (portréty)',
  'Any subject (objects, animals, products)':
    'Cokoli (předměty, zvířata, výrobky)',
  'Each needs a one-time download – the size is shown before anything is downloaded. Everything runs on this device.':
    'Každé potřebuje jednorázové stažení – velikost uvidíte dřív, než se cokoli stáhne. Vše běží v tomto zařízení.',
  'Select the subject':
    'Vybrat hlavní objekt',
  'Finding the subject…':
    'Hledá se hlavní objekt…',
  'The subject is selected.':
    'Hlavní objekt je vybraný.',
  'Background removed.':
    'Pozadí odstraněno.',
  'Could not load the text recognition.':
    'Rozpoznávání textu se nepodařilo načíst.',
  'Reading the text…':
    'Čte se text…',
  'Text in the picture':
    'Text na obrázku',
  'You can correct it here before copying.':
    'Před zkopírováním ho tu můžete opravit.',
  'Copied.':
    'Zkopírováno.',
  'Select the text and copy it (Ctrl+C).':
    'Označte text a zkopírujte ho (Ctrl+C).',
  'No text found.':
    'Žádný text se nenašel.',
  '3D relief':
    '3D reliéf',
  'A 3D-printable relief of the picture (STL): from its brightness, or from the depth an AI sees in a photo.':
    'Reliéf obrázku pro 3D tisk (STL): podle jasu, nebo podle hloubky, kterou ve fotce vidí AI.',
  'Brightness – light is high':
    'Jas – světlé je vysoko',
  'Brightness – dark is high (a lithophane: hold it against light)':
    'Jas – tmavé je vysoko (litofanie: podržte ji proti světlu)',
  'Depth (AI add-on) – near is high':
    'Hloubka (doplněk AI) – blízké je vysoko',
  'Relief':
    'Reliéf',
  'Low':
    'Nízké',
  'Medium':
    'Střední',
  'High':
    'Vysoké',
  'Smoothing':
    'Vyhlazení',
  'Height map: white is high':
    'Výšková mapa: bílá je vysoko',
  'Save STL':
    'Uložit STL',
  'Working out the depth…':
    'Zjišťuje se hloubka…',
  '{w} × {h} mm, {z} mm high':
    '{w} × {h} mm, výška {z} mm',
  'Saved relief.stl.':
    'Uloženo relief.stl.',
  'Select object (AI)':
    'Výběr objektu (AI)',
  'Tap an object to select it.':
    'Klepnutím na objekt ho vyberete.',
  'Object removal (AI)':
    'Odstraňování objektů (AI)',
  'Remove fills the spot with a trained model – better on objects and structure than the built-in fill.':
    'Odstranit vyplní místo natrénovaným modelem – lépe než vestavěné vyplnění u objektů a struktur.',
  'Background removal – people':
    'Odstranění pozadí – lidé',
  'Removes the background behind people (portraits).':
    'Odstraní pozadí za lidmi (portréty).',
  'Background removal – any subject':
    'Odstranění pozadí – cokoli',
  'Removes the background behind the main subject: objects, animals, products.':
    'Odstraní pozadí za hlavním objektem: předměty, zvířata, výrobky.',
  'Read text (OCR)':
    'Čtení textu (OCR)',
  'Recognizes text in the image, to copy it.':
    'Rozpozná text v obrázku, abyste ho mohli zkopírovat.',
  'Depth for 3D relief (AI)':
    'Hloubka pro 3D reliéf (AI)',
  'Estimates the depth of a photo for a 3D-printable relief.':
    'Odhadne hloubku fotky pro reliéf k 3D tisku.',
  'Download failed ({status}).':
    'Stahování selhalo ({status}).',
  'This needs a one-time download of {size}.':
    'Potřebuje to jednorázově stáhnout {size}.',
  'That includes the AI engine ({size}), shared by all AI add-ons.':
    'To zahrnuje jádro AI ({size}), společné pro všechny doplňky AI.',
  'It is kept in this browser and works offline afterwards; the Add-ons list in the side panel removes it again. Everything runs on this device – your pictures are not uploaded.':
    'Zůstane v tomto prohlížeči a pak funguje i offline; v seznamu Doplňky v postranním panelu ho zase odstraníte. Vše běží v tomto zařízení – vaše obrázky se nikam nenahrávají.',
  'Download {size}':
    'Stáhnout {size}',
  'Downloading…':
    'Stahuje se…',
  '{name} is ready.':
    '{name} je připraveno.',
  'Could not download it: {why}':
    'Nepodařilo se stáhnout: {why}',
  'installed':
    'staženo',
  'Download':
    'Stáhnout',
  'Used by add-ons: {size}. Sizes include the shared AI engine where it is not downloaded yet.':
    'Doplňky zabírají: {size}. Velikosti zahrnují společné jádro AI, pokud ještě není stažené.',
  'Removed the add-on.':
    'Doplněk odstraněn.',
  'Object (AI)':
    'Objekt (AI)',
  'Remove background…':
    'Odstranit pozadí…',
  'Read text…':
    'Přečíst text…',
  '3D relief…':
    '3D reliéf…',
  'Add-ons':
    'Doplňky',
  'Features that need a one-time download. Nothing is downloaded until you agree; everything runs on this device.':
    'Funkce, které potřebují jednorázové stažení. Nic se nestáhne, dokud nesouhlasíte; vše běží v tomto zařízení.',
  'Tap an object: the AI selects it (an add-on – asks before downloading)':
    'Klepněte na objekt: AI ho vybere (doplněk – před stažením se zeptá)',
  'Make the background transparent, or select the subject (an AI add-on – asks before downloading)':
    'Zprůhlednit pozadí, nebo vybrat hlavní objekt (doplněk AI – před stažením se zeptá)',
  'Recognize the text in the image or the selection, to copy it (an add-on – asks before downloading)':
    'Rozpoznat text v obrázku nebo výběru a zkopírovat ho (doplněk – před stažením se zeptá)',
  'A 3D-printable relief (STL) from the picture\'s brightness, or from AI depth':
    'Reliéf pro 3D tisk (STL) podle jasu obrázku, nebo podle hloubky z AI',
  'Add-ons that run on your device, each downloaded only after you agree to its size: Select object (tap it), AI object removal, background removal, Read text (OCR) and depth for 3D reliefs. The side panel lists them and removes them again.':
    'Doplňky, které běží ve vašem zařízení a stáhnou se až po odsouhlasení velikosti: Výběr objektu (klepnutím), odstraňování objektů AI, odstranění pozadí, Čtení textu (OCR) a hloubka pro 3D reliéfy. Postranní panel je vypisuje a umí je zase odstranit.',
  '3D relief…: a printable relief (STL) from the picture\'s brightness – or a lithophane – or from AI depth.':
    '3D reliéf…: reliéf k tisku (STL) podle jasu obrázku – nebo litofanie – nebo podle hloubky z AI.',
  'Layer {n}':
    'Vrstva {n}',
  'Saved as one picture – Save layers (.ora) in the Layers section keeps the layers.':
    'Uloženo jako jeden obrázek – vrstvy zachová Uložit vrstvy (.ora) v části Vrstvy.',
  'The last layer can’t be deleted.':
    'Poslední vrstvu nelze smazat.',
  'There is no layer under this one.':
    'Pod touto vrstvou žádná není.',
  'Name of the layer:':
    'Název vrstvy:',
  'Hide this layer':
    'Skrýt tuto vrstvu',
  'Show this layer':
    'Zobrazit tuto vrstvu',
  'Show {name}':
    'Zobrazit {name}',
  'Saved {name} with {n} {n|layer|layers}.':
    'Uloženo {name} s {n} {n|vrstvou|vrstvami|vrstvami}.',
  'Opened {name} ({n} {n|layer|layers}).':
    'Otevřeno {name} ({n} {n|vrstva|vrstvy|vrstev}).',
  'Could not read this OpenRaster file.':
    'Tento soubor OpenRaster se nepodařilo přečíst.',
  'Merge down':
    'Sloučit dolů',
  'Flatten':
    'Sloučit vše',
  'Save layers (.ora)':
    'Uložit vrstvy (.ora)',
  'Painting and the other tools work on the active layer. Tap a layer to make it active, double-click to rename. Save keeps the picture as it looks; Save layers keeps the layers.':
    'Malování a ostatní nástroje pracují v aktivní vrstvě. Klepnutím vrstvu aktivujete, dvojklikem přejmenujete. Uložit uloží obrázek, jak vypadá; Uložit vrstvy zachová vrstvy.',
  'Layers (.ora)':
    'Vrstvy (.ora)',
  'Layers – the top one first':
    'Vrstvy – horní první',
  'A new, empty layer above this one':
    'Nová prázdná vrstva nad touto',
  'A copy of this layer':
    'Kopie této vrstvy',
  'Move this layer up':
    'Posunout vrstvu nahoru',
  'Move up':
    'Nahoru',
  'Move this layer down':
    'Posunout vrstvu dolů',
  'Move down':
    'Dolů',
  'Delete this layer':
    'Smazat tuto vrstvu',
  'Put this layer onto the one under it':
    'Vložit tuto vrstvu do té pod ní',
  'All the layers as one':
    'Všechny vrstvy v jednu',
  'Save every layer in one file (OpenRaster – GIMP, Krita and others open it); Open… opens it again':
    'Uložit všechny vrstvy do jednoho souboru (OpenRaster – otevře ho GIMP, Krita a další); Otevřít… ho zase otevře',
  'Layers in the raster app: paint on the active layer, show / hide, opacity, move, merge, flatten – undo knows them all. Save layers keeps them in an OpenRaster file (.ora – GIMP and Krita open it), and autosave keeps them too.':
    'Vrstvy v rastrové aplikaci: malování do aktivní vrstvy, zobrazení / skrytí, krytí, přesun, sloučení – Zpět zná všechno. Uložit vrstvy je zachová v souboru OpenRaster (.ora – otevře ho GIMP i Krita) a zachová je i automatické ukládání.',
  'The AI add-ons on phones: much less memory (no more crash on iPhone when selecting an object) – the CPU engine on iPhone and iPad, and one feature\'s models at a time.':
    'Doplňky AI na telefonech: mnohem méně paměti (výběr objektu už na iPhonu nespadne) – na iPhonu a iPadu jádro pro procesor a vždy jen modely jedné funkce.',
  'Frame {n} of {count}':
    'Snímek {n} z {count}',
  '{s} s of {total} s':
    '{s} s z {total} s',
  'Choose a frame':
    'Vyberte snímek',
  'One frame back':
    'O snímek zpět',
  'Play / pause':
    'Přehrát / pozastavit',
  'One frame on':
    'O snímek dál',
  'Use this frame':
    'Použít tento snímek',
  'This video can’t be played here – try a GIF or a screenshot of it.':
    'Toto video tu nejde přehrát – zkuste GIF nebo jeho snímek obrazovky.',
  'GIFs and videos: open one (or, in Discord, a GIF, a video or a Tenor / Giphy GIF from the chat) and choose the frame to edit – with a slider, frame steps and play.':
    'GIFy a videa: otevřete je (v Discordu i GIF, video nebo GIF z Tenoru / Giphy z chatu) a vyberte snímek k úpravě – posuvníkem, po snímcích nebo přehráním.',
  'Everything was selected – now nothing is.':
    'Vybráno bylo vše – teď není nic.',
  'Invert':
    'Obrátit',
  'Select the other shapes instead (Ctrl+I)':
    'Vybrat místo toho ostatní tvary (Ctrl+I)',
  'Adjust':
    'Úpravy',
  'Invert selection':
    'Obrátit výběr',
  'Invert the selection':
    'Obrátit výběr',
  'Brightness, contrast, warmth and the other photo sliders – for the selection or the whole image':
    'Jas, kontrast, teplota a další posuvníky pro fotky – pro výběr nebo celý obrázek',
  'Select what isn\'t selected (Ctrl+I)':
    'Vybrat, co vybrané není (Ctrl+I)',
  'Light':
    'Světlo',
  'Detail and effects':
    'Detaily a efekty',
  'Levels':
    'Úrovně',
  'Vibrance':
    'Živost',
  'Warmth':
    'Teplota',
  'Tint':
    'Odstín',
  'Fade':
    'Vybledlost',
  'Vignette':
    'Vinětace',
  'Black point':
    'Bod černé',
  'White point':
    'Bod bílé',
  'Shadows':
    'Stíny',
  'Highlights':
    'Světla',
  'Midtones':
    'Střední tóny',
  'Nicer icons for undo / redo, zoom, fit and help; Adjust is in the toolbar and the quick menu, with new sliders – shadows, highlights, warmth, tint, vibrance, fade and vignette. Invert selection (Ctrl+I) in both apps.':
    'Hezčí ikony pro zpět / znovu, přiblížení, přizpůsobení a nápovědu; Úpravy jsou na liště i v rychlé nabídce s novými posuvníky – stíny, světla, teplota, odstín, živost, vybledlost a vinětace. Obrácení výběru (Ctrl+I) v obou aplikacích.',
  'Select object (AI) no longer crashes on phones: it now uses MobileSAM, which needs a quarter of the memory (and is faster). Its download is larger (45 MB); the old model is removed.':
    'Výběr objektu (AI) už na telefonech nepadá: teď používá MobileSAM, který potřebuje čtvrtinu paměti (a je rychlejší). Stahování je větší (45 MB); starý model se odstraní.',
  'Import a picture':
    'Vložit obrázek ze souboru',
  'Put a picture from a file into this image – drag it into place, then press Enter (or tap outside it)':
    'Vložit obrázek ze souboru do tohoto obrázku – přetáhněte ho na místo a stiskněte Enter (nebo klepněte mimo něj)',
  'Import… puts a picture from a file into the current image (also in the quick menu): it comes in floating, scaled to fit – drag it into place.':
    'Vložit… přidá obrázek ze souboru do aktuálního obrázku (i v rychlé nabídce): přijde jako plovoucí, zmenšený, aby se vešel – přetáhněte ho na místo.',
  'Two fingers on a selection':
    'Dva prsty na výběru',
  'Scale, turn and move it (spread, pinch, twist)':
    'Zvětšit, zmenšit, otočit a posunout (roztažení, sevření, otočení prstů)',
  'Two fingers on a selection (or a pasted, imported picture or text) scale and turn it: spread or pinch, twist – and move it. It snaps upright and to its own size, and is always made from the original pixels, so it doesn’t blur. Elsewhere two fingers zoom the view as before.':
    'Dva prsty na výběru (nebo na vloženém či importovaném obrázku a textu) ho zvětší, zmenší a otočí: roztáhněte nebo sevřete prsty, otočte jimi – a posuňte ho. Přichytí se ke svislé poloze a k původní velikosti a vždy vzniká z původních pixelů, takže se nerozmazává. Jinde dva prsty přibližují zobrazení jako dřív.',
  'On phones, the Select shapes (and other rows of choices) wrap onto a second line instead of cutting off the last one – Object (AI) can be tapped again.':
    'Na telefonech se tvary výběru (i jiné řady voleb) zalomí na druhý řádek, místo aby se poslední uřízla – Výběr objektu (AI) jde zase stisknout.',
  'Drag a corner of the selection':
    'Tažení za roh výběru',
  'Scale it (the opposite corner stays)':
    'Zvětšit či zmenšit (protější roh zůstane na místě)',
  'Scale a selection with the mouse: drag one of the handles in its corners – the opposite corner stays put and the proportions are kept. As with two fingers, it is always made from the original pixels.':
    'Změna velikosti výběru myší: táhněte za jeden z úchytů v jeho rozích – protější roh zůstane na místě a poměr stran se zachová. Stejně jako u dvou prstů vzniká vždy z původních pixelů.',
  'Paint to soften – edges of pasted photos blend in · [ ] size · a soft tip blends best':
    'Malováním změkčíte – okraje vložených fotek splynou · [ ] velikost · nejlépe splývá měkký hrot',
  'Paint to add grain – a smooth patch matches the photo around it · [ ] size':
    'Malováním přidáte zrno – hladká plocha ladí s fotkou kolem · [ ] velikost',
  'Blur':
    'Rozmazání',
  'Noise':
    'Šum',
  'Strength':
    'Síla',
  'Amount':
    'Množství',
  'Colored grain':
    'Barevné zrno',
  'To blend a photo in: blur along its edge, then add a little grain so it matches the picture around it. Each stroke adds more; the tip and opacity are the brush\'s.':
    'Jak fotku napojit: rozmažte její okraj a pak přidejte trochu zrna, aby ladila s obrázkem kolem. Každý tah přidá víc; hrot a krytí jsou jako u štětce.',
  'Blur – paint to soften: blends the edges of a pasted photo into the picture (U)':
    'Rozmazání – malováním změkčíte: okraje vložené fotky splynou s obrázkem (U)',
  'Noise – paint to add grain: makes a smooth or pasted part match a photo\'s texture (N)':
    'Šum – malováním přidáte zrno: hladká nebo vložená část dostane texturu fotky (N)',
  'How soft: about this many pixels':
    'Jak měkce: zhruba o tolik pixelů',
  'How much grain':
    'Kolik zrna',
  'Off: the same grain in red, green and blue (like film). On: each its own':
    'Vypnuto: stejné zrno v červené, zelené i modré (jako film). Zapnuto: každá barva své',
  'Blur (U) and Noise (N) brushes, to blend photos into each other: blur along the edge of a pasted photo to soften it (a cut-out’s edge fades out), then add a little grain so it matches the picture around it.':
    'Štětce Rozmazání (U) a Šum (N) pro napojování fotek: rozmažte okraj vložené fotky, aby změkl (okraj výřezu se vytratí), a přidejte trochu zrna, aby ladila s obrázkem kolem.',
  'In a narrower window the top bar scrolls on its own instead of pushing the whole page sideways (the canvas could slide out of view).':
    'V užším okně se horní lišta posouvá sama, místo aby odsunula celou stránku do strany (plátno mohlo zmizet z dohledu).',
  'Compress video…':
    'Zmenšit video…',
  'Make a video small enough for Discord – on your device – and post it here':
    'Zmenšit video tak, aby se vešlo do Discordu – ve vašem zařízení – a zveřejnit ho tady',
  'Compress a video':
    'Zmenšit video',
  'The video is made smaller on your device, then posted to the channel.':
    'Video se zmenší ve vašem zařízení a pak se zveřejní v kanálu.',
  'Choose a video…':
    'Vybrat video…',
  'Small enough already – it is posted as it is.':
    'Už je dost malé – zveřejní se tak, jak je.',
  'Use as it is':
    'Použít, jak je',
  'Compress':
    'Zmenšit',
  'Too long for {size} MB – the picture would be very poor. Choose the larger size or a shorter video.':
    'Na {size} MB je moc dlouhé – obraz by byl velmi špatný. Zvolte větší velikost nebo kratší video.',
  '→ about {w} × {h}, {rate} Mbit/s':
    '→ asi {w} × {h}, {rate} Mbit/s',
  'Opening {name}…':
    'Otevírám {name}…',
  'This video can’t be read here – try another one (MP4, MOV or WebM).':
    'Toto video tu nejde přečíst – zkuste jiné (MP4, MOV nebo WebM).',
  'Could not compress the video.':
    'Video se nepodařilo zmenšit.',
  '{size} (was {before})':
    '{size} (bylo {before})',
  'without sound (this browser can’t make it)':
    'bez zvuku (tento prohlížeč ho neumí vytvořit)',
  'still too big – choose the larger size or a shorter video':
    'pořád moc velké – zvolte větší velikost nebo kratší video',
  'Discord did not take a video this big – try 10 MB.':
    'Discord tak velké video nepřijal – zkuste 10 MB.',
  'Use “Compress video” on a message or /compress-video in this chat to post here.':
    'Pro zveřejnění tady použijte „Compress video“ na zprávě nebo /compress-video v tomto chatu.',
  'More than 15 minutes have passed, and Discord no longer lets the app post. Run /compress-video again.':
    'Uplynulo víc než 15 minut a Discord už aplikaci nedovolí nic zveřejnit. Spusťte /compress-video znovu.',
  'Discord did not take the video.':
    'Discord video nepřijal.',
  'Choose a video from your device.':
    'Vyberte video ze svého zařízení.',
  'Discord: compress a video to fit Discord’s limit and post it – right-click a message with a video › Apps › Compress video, or /compress-video for a video from your device. It is made smaller on your device (20 MB or 10 MB), shown, then posted.':
    'Discord: zmenšete video, aby se vešlo do limitu Discordu, a zveřejněte ho – pravým tlačítkem na zprávu s videem › Aplikace › Compress video, nebo /compress-video pro video ze zařízení. Zmenší se ve vašem zařízení (20 MB nebo 10 MB), ukáže se a pak zveřejní.',
  'Turn left 90°':
    'Otočit doleva o 90°',
  'Turn right 90°':
    'Otočit doprava o 90°',
  'Flip horizontally':
    'Překlopit vodorovně',
  'Flip vertically':
    'Překlopit svisle',
  'Duplicate – leave a copy here and move this one on':
    'Duplikovat – kopie zůstane tady a tento se posune dál',
  'Delete the selected pixels (Del)':
    'Smazat vybrané pixely (Del)',
  'Drag the knob above a selection':
    'Tažení úchytu nad výběrem',
  'Turn it (Shift: 15° steps)':
    'Otočit (Shift: po 15°)',
  'A selection now has a knob above it to turn it (it snaps upright; Shift: 15° steps) and a bar below it: turn left / right, flip horizontally / vertically, duplicate, delete, cancel, place – with the mouse or a finger.':
    'Výběr má teď nad sebou úchyt k otáčení (přichytí se svisle; Shift: po 15°) a pod sebou lištu: otočit doleva / doprava, překlopit vodorovně / svisle, duplikovat, smazat, zrušit, umístit – myší i prstem.',
  'Press at the centre, drag out for the size, then go round it to twist – the further round, the stronger · lift to finish':
    'Stiskněte ve středu, táhněte ven pro velikost, pak kružte kolem a kruťte – čím dál kolem, tím silněji · zvednutím dokončíte',
  'Twist':
    'Zkroucení',
  'Press where the swirl\'s centre should be and drag out: the circle shows how far it reaches. Then go round the centre – the further round, the stronger the twist (back the other way to undo it). Lift to finish; with a selection, only the selected pixels twist.':
    'Stiskněte tam, kde má být střed víru, a táhněte ven: kruh ukazuje, kam až sahá. Pak kružte kolem středu – čím dál kolem, tím silnější zkroucení (zpátky ho vrátíte). Zvednutím dokončíte; s výběrem se zkroutí jen vybrané pixely.',
  'Twist – press, drag out for the size, go round to swirl the picture (W)':
    'Zkroucení – stiskněte, táhněte ven pro velikost, kružte kolem a obrázek se zavíří (W)',
  'Twist tool (W): press where the swirl’s centre should be, drag out for its size, then go round – the further round, the stronger the twist (either way). With a selection, only the selected pixels twist.':
    'Nástroj Zkroucení (W): stiskněte tam, kde má být střed víru, táhněte ven pro jeho velikost a pak kružte kolem – čím dál kolem, tím silnější zkroucení (oběma směry). S výběrem se zkroutí jen vybrané pixely.',
  'Click a line or shape to pick it, then drag it – or press Delete':
    'Klikni na čáru nebo tvar, vyber ho a pak ho přetáhni – nebo stiskni Delete',
  'Drag to draw a line – it sticks to the lines and corners already there':
    'Táhni a nakresli čáru – přichytí se k čarám a rohům, které už tam jsou',
  'Drag from the middle to draw a shape – pick how many corners on the right':
    'Táhni od středu a nakresli tvar – vpravo vyber, kolik má mít rohů',
  'Drag to draw a circle or an oval':
    'Táhni a nakresli kruh nebo ovál',
  'Click inside an area to fill it with tiles':
    'Klikni dovnitř plochy a vyplň ji dlaždicemi',
  'Pick a color, then click a tile to paint it – or drag across many tiles':
    'Vyber barvu a klikni na dlaždici, aby se vybarvila – nebo táhni přes víc dlaždic',
  'Make a mosaic: draw the lines between the tiles, or fill an area with tiles, then paint each tile.':
    'Udělej si mozaiku: nakresli čáry mezi dlaždicemi nebo vyplň plochu dlaždicemi, pak každou dlaždici vybarvi.',
  'Pick a tool on the left: Line, Shapes and Circles draw, Tiles fills an area with tiles, Paint colors a tile when you click it.':
    'Vlevo vyber nástroj: Čára, Tvary a Kruhy kreslí, Dlaždice vyplní plochu dlaždicemi, Barva vybarví dlaždici, na kterou klikneš.',
  'Click a color, then click the tiles with Paint. Made a mistake? The arrow at the top takes it back.':
    'Klikni na barvu a pak na dlaždice s nástrojem Barva. Spletl ses? Šipka nahoře to vrátí.',
  'Shapes':
    'Tvary',
  'Circles':
    'Kruhy',
  'Small tiles':
    'Malé dlaždice',
  'Big':
    'Velké',
  'Simple: only the drawing tools and the colors – for children and quick mosaics. Expert: everything':
    'Jednoduchý: jen kreslicí nástroje a barvy – pro děti a rychlé mozaiky. Expert: všechno',
  'Tile size':
    'Velikost dlaždic',
  'The vector app’s Simple mode is now made for children: only the basic tools (with a word under each) – Select, Line, Shapes, Circles, Tiles, Paint – and big colors; on phones and tablets the colors are along the bottom too. Everything else is in Expert mode.':
    'Jednoduchý režim vektorové aplikace je teď pro děti: jen základní nástroje (každý s popiskem) – Výběr, Čára, Tvary, Kruhy, Dlaždice, Barva – a velké barvy; na telefonech a tabletech jsou barvy i dole. Všechno ostatní je v režimu Expert.',
  'Remove the picture?':
    'Odstranit obrázek?',
  'Picture loaded – draw over it.':
    'Obrázek je načtený – kresli přes něj.',
  'Choose another picture…':
    'Vybrat jiný obrázek…',
  'Choose a picture…':
    'Vybrat obrázek…',
  'Shards':
    'Střepy',
  'Hand-laid lines':
    'Ručně kladené spáry',
  'Uneven, tapered lines – as if the shards were laid by hand':
    'Nerovné, zužující se spáry – jako by střepy kladl člověk',
  'Shuffle':
    'Zamíchat',
  'Unevenness':
    'Nerovnost',
  'Picture to draw over':
    'Obrázek pod kresbou',
  'Shards – uneven, tapered lines, as if the glass were laid by hand (click again: even lines)':
    'Střepy – nerovné, zužující se spáry, jako by sklo kladl člověk (znovu: rovné spáry)',
  'Other widths for every piece':
    'Jiné šířky pro každý kousek',
  'Simple mode: Choose a picture… puts a picture under the drawing to draw the tile shapes over (it can fade, or go).':
    'Jednoduchý režim: Vybrat obrázek… vloží obrázek pod kresbu, přes který kreslíš tvary dlaždic (lze ho zesvětlit nebo odstranit).',
  'Shards (both modes): uneven, tapered lines, as if glass shards were laid by hand – every piece between two crossings gets its own width, wider at one end. Shuffle for other widths; Unevenness in the panel. The lines stay as they are underneath; files and pictures keep the look.':
    'Střepy (v obou režimech): nerovné, zužující se spáry, jako by skleněné střepy kladl člověk – každý kousek mezi dvěma křížením má vlastní šířku, na jednom konci širší. Zamíchat dá jiné šířky; Nerovnost je v panelu. Čáry pod tím zůstanou, jak jsou; soubory i obrázky ten vzhled zachovají.',
  'Off: every tile gets the one color you picked. Turn it on to give each tile one of these {n} colors at random.':
    'Vypnuto: každá dlaždice dostane tu jednu barvu, kterou vybereš. Zapni to a každá dlaždice dostane náhodně jednu z těchto {n} barev.',
  'Mixing off – painting with one color. (Mix colors in the Paint options turns it on again.)':
    'Míchání vypnuto – maluje se jednou barvou. (Zapne ho znovu Míchat barvy v možnostech Barvy.)',
  '＋ Add a color':
    '＋ Přidat barvu',
  'Clear palette':
    'Vymazat paletu',
  'Choose any color and add it to the palette':
    'Vybrat libovolnou barvu a přidat ji do palety',
  'Remove all colors from the palette':
    'Odebrat z palety všechny barvy',
  'Picking one color (a swatch without Shift) switches the color mix off – the bucket paints with that color. The Mix colors switch shows in Simple mode too, and so do ＋ Add a color and Clear palette.':
    'Výběr jedné barvy (vzorník bez Shiftu) vypne míchání barev – kyblík maluje touto barvou. Přepínač Míchat barvy je i v jednoduchém režimu, stejně jako ＋ Přidat barvu a Vymazat paletu.',
  'Set up the palette':
    'Nastavit paletu',
  'Copy colors on any website – a palette site, color codes, a list – and paste them here (Ctrl+V). Every color found shows below; click one to leave it out.':
    'Zkopíruj barvy na jakékoli webové stránce – na webu s paletami, kódy barev, seznam – a vlož je sem (Ctrl+V). Každá nalezená barva se ukáže níže; kliknutím ji vynecháš.',
  'Paste from clipboard':
    'Vložit ze schránky',
  'Colors to paste':
    'Barvy k vložení',
  'Colors found':
    'Nalezené barvy',
  'Add to my palette':
    'Přidat do mé palety',
  'Use instead of my palette':
    'Použít místo mé palety',
  'Use these colors':
    'Použít tyto barvy',
  '{n} {n|color|colors} found.':
    '{n|Nalezena|Nalezeny|Nalezeno} {n} {n|barva|barvy|barev}.',
  'No colors found in this text – copy the color codes (like #2a9d8f), not just the picture.':
    'V tomto textu nejsou žádné barvy – zkopíruj kódy barev (třeba #2a9d8f), ne jen obrázek.',
  'This browser won’t let the page read the clipboard – click in the box and press Ctrl+V.':
    'Tento prohlížeč stránce nedovolí číst schránku – klikni do pole a stiskni Ctrl+V.',
  'The palette now has {n} {n|color|colors}.':
    'Paleta má teď {n} {n|barvu|barvy|barev}.',
  'Added {n} {n|color|colors} to the palette.':
    'Do palety {n|přibyla|přibyly|přibylo} {n} {n|barva|barvy|barev}.',
  'All these colors are in the palette already.':
    'Všechny tyto barvy už v paletě jsou.',
  'Paste colors…':
    'Vložit barvy…',
  'Paste colors copied on another website':
    'Vložit barvy zkopírované na jiném webu',
  'Visible – click to hide':
    'Viditelná – kliknutím skryjete',
  'Hidden – click to show':
    'Skrytá – kliknutím zobrazíte',
  'Locked – click to unlock':
    'Zamčená – kliknutím odemknete',
  'Unlocked – click to lock':
    'Odemčená – kliknutím zamknete',
  'Paste colors… sets up the palette from colors copied on another website – a palette site like Coolors, color codes, CSS: every color found shows, click one to leave it out, then add them or use them instead of the palette (both apps).':
    'Vložit barvy… nastaví paletu z barev zkopírovaných na jiném webu – na webu s paletami jako Coolors, kódy barev, CSS: každá nalezená barva se ukáže, kliknutím ji vynecháš, pak je přidáš nebo použiješ místo palety (v obou aplikacích).',
  'done':
    'hotovo',
  '{n} of {m} tasks done':
    'Hotovo {n} z {m} úkolů',
  'Next: {title}':
    'Další: {title}',
  'Look around':
    'Rozhlédni se',
  'A ladybird is hiding in the meadow. Zoom in and find it!':
    'Na louce se schovává beruška. Přibliž si obrázek a najdi ji!',
  'Zoom in to see details, move around with the hand (or two fingers), and Fit shows the whole picture.':
    'Přiblížením uvidíš detaily, ručičkou (nebo dvěma prsty) se posouváš a Přizpůsobit ukáže celý obrázek.',
  'Tap Zoom in to look closer.':
    'Klepni na Přiblížit a podívej se blíž.',
  'Spread two fingers on the picture to zoom in.':
    'Roztáhni dva prsty na obrázku a přiblížíš ho.',
  'Tap the hand – it moves the picture.':
    'Klepni na ručičku – posouvá obrázek.',
  'Drag the picture until you find the ladybird.':
    'Táhni obrázek, dokud nenajdeš berušku.',
  'You found it! Now tap Fit to see the whole picture again.':
    'Máš ji! Teď klepni na Přizpůsobit a uvidíš zase celý obrázek.',
  'Night sky':
    'Noční obloha',
  'The night sky needs glowing stars. Paint them with a soft brush.':
    'Noční obloha potřebuje zářící hvězdy. Namaluj je měkkým štětcem.',
  'The Brush paints soft lines. Size makes it bigger, and the Soft tip makes it glow at the edges.':
    'Štětec maluje měkké čáry. Velikost ho zvětší a měkký hrot ho na okrajích rozzáří.',
  'Tap the Brush.':
    'Klepni na Štětec.',
  'Tap the yellow color.':
    'Klepni na žlutou barvu.',
  'Choose the Soft tip – it glows at the edges.':
    'Vyber měkký hrot – na okrajích září.',
  'Make the brush big: slide Size to 30 or more.':
    'Zvětši štětec: posuň Velikost na 30 nebo víc.',
  'Paint over the 3 stars.':
    'Přemaluj 3 hvězdy.',
  'Fill the heart square by square – like a real mosaic.':
    'Vyplň srdce čtvereček po čtverečku – jako skutečnou mozaiku.',
  'The Pencil paints whole squares in exactly the chosen color – just right for pixel art.':
    'Tužka maluje celé čtverečky přesně vybranou barvou – akorát pro pixel art.',
  'Tap the Pencil.':
    'Klepni na Tužku.',
  'Tap the red color.':
    'Klepni na červenou barvu.',
  'Make the pencil as small as it goes: slide Size all the way left.':
    'Zmenši tužku, co nejvíc to jde: posuň Velikost úplně doleva.',
  'Fill the inside of the heart, square by square.':
    'Vyplň vnitřek srdce, čtvereček po čtverečku.',
  'Muddy window':
    'Zablácené okno',
  'Someone threw mud at the window. Rub it off!':
    'Někdo hodil na okno bláto. Vygumuj ho!',
  'The Eraser takes paint away – where it rubs, the picture becomes see-through (the checkerboard).':
    'Guma barvu odebírá – kde gumuje, je obrázek průhledný (šachovnice).',
  'Tap the Eraser.':
    'Klepni na Gumu.',
  'Make it big: slide Size to 30 or more.':
    'Zvětši ji: posuň Velikost na 30 nebo víc.',
  'Rub out the 4 mud spots.':
    'Vygumuj 4 skvrny od bláta.',
  'Copy the color':
    'Okopíruj barvu',
  'The parrot lost a feather. Paint a new one in exactly the same purple.':
    'Papoušek ztratil pero. Namaluj nové přesně stejnou fialovou.',
  'The color picker takes a color from the picture. (Tip: Alt+click does it with any brush.)':
    'Kapátko vezme barvu z obrázku. (Tip: s jakýmkoli štětcem to udělá Alt+klik.)',
  'Tap the color picker – the dropper.':
    'Klepni na Kapátko.',
  'Tap a purple feather to take its color.':
    'Klepni na fialové pero a vezmeš si jeho barvu.',
  'Now take the Brush.':
    'Teď vezmi Štětec.',
  'Make it bigger: Size 20 or more.':
    'Zvětši ho: Velikost 20 nebo víc.',
  'Paint the white feather purple.':
    'Namaluj bílé pero fialově.',
  'Color the comic':
    'Vybarvi komiks',
  'Fill the shapes with color – one tap each.':
    'Vyplň tvary barvou – každý jedním klepnutím.',
  'The Paint bucket fills a whole area at once. Tolerance decides how different the colors in it may be.':
    'Kyblík vyplní celou plochu najednou. Tolerance určuje, jak moc se v ní můžou barvy lišit.',
  'Tap the Paint bucket.':
    'Klepni na Kyblík.',
  'Tap the orange color.':
    'Klepni na oranžovou barvu.',
  'Tap inside the circle, the square and the triangle.':
    'Klepni dovnitř kruhu, čtverce a trojúhelníku.',
  'This box is shaded. Slide Tolerance up to 60 or more.':
    'Tenhle obdélník je stínovaný. Posuň Toleranci na 60 nebo víc.',
  'Now tap inside the shaded box – all of it fills.':
    'Teď klepni dovnitř stínovaného obdélníku – vyplní se celý.',
  'Fence':
    'Plot',
  'The garden needs a fence. Draw the posts with straight lines.':
    'Zahrada potřebuje plot. Nakresli sloupky rovnými čarami.',
  'The Line tool draws straight lines from where you press to where you let go.':
    'Čára kreslí rovné čáry od místa, kde stiskneš, po místo, kde pustíš.',
  'Tap the Line tool.':
    'Klepni na nástroj Čára.',
  'Tap the dark color.':
    'Klepni na tmavou barvu.',
  'Make the line thicker: Size 8 or more.':
    'Zesil čáru: Velikost 8 nebo víc.',
  'Draw a line from each bottom dot up to the dot above it.':
    'Nakresli čáru od každé spodní tečky nahoru k tečce nad ní.',
  'Beehive':
    'Úl',
  'Bees build cells with 6 sides. Draw 3 honeycomb cells.':
    'Včely stavějí buňky se 6 stranami. Nakresli 3 plástve.',
  'The Polygon tool draws shapes with as many sides as you choose – filled, outlined or both.':
    'Mnohoúhelník kreslí tvary s tolika stranami, kolik zvolíš – vyplněné, obtažené nebo obojí.',
  'Tap the Polygon tool.':
    'Klepni na nástroj Mnohoúhelník.',
  'Tap 6 – a honeycomb cell has 6 sides.':
    'Klepni na 6 – buňka plástve má 6 stran.',
  'Turn on Fill – the cells will be full of color.':
    'Zapni Výplň – buňky budou plné barvy.',
  'Drag from the middle of each cell outwards.':
    'Táhni od středu každé buňky ven.',
  'Bubbles':
    'Bubliny',
  'Blow 3 round soap bubbles – just the outline, you can see through them.':
    'Vyfoukni 3 kulaté mýdlové bubliny – jen obrys, je skrz ně vidět.',
  'The Ellipse tool draws circles and ovals. From center starts in the middle; Fill and Outline decide how it looks.':
    'Elipsa kreslí kruhy a ovály. Od středu začíná uprostřed; Výplň a Obrys určují, jak vypadá.',
  'Tap the Ellipse tool.':
    'Klepni na nástroj Elipsa.',
  'Choose From center.':
    'Vyber Od středu.',
  'Turn Fill off – a bubble is see-through.':
    'Vypni Výplň – bublina je průhledná.',
  'Turn Outline on.':
    'Zapni Obrys.',
  'Drag from the middle of each bubble to its edge.':
    'Táhni od středu každé bubliny k jejímu okraji.',
  'Snake':
    'Had',
  'Draw a wiggly snake through the dots.':
    'Nakresli vlnitého hada přes tečky.',
  'The Curve tool draws a smooth line through the points you tap – double-tap (or Enter) finishes it.':
    'Křivka kreslí hladkou čáru přes body, na které klepneš – dvojí klepnutí (nebo Enter) ji dokončí.',
  'Tap the Curve tool.':
    'Klepni na nástroj Křivka.',
  'Tap the green color.':
    'Klepni na zelenou barvu.',
  'Make it a fat snake: Size 10 or more.':
    'Ať je had tlustý: Velikost 10 nebo víc.',
  'Tap the dots one by one from the head to the tail – tap the last one twice to finish.':
    'Klepej na tečky jednu po druhé od hlavy k ocasu – na poslední klepni dvakrát a je hotovo.',
  'Move the cat':
    'Přesuň kočku',
  'The cat wants to sleep on the red cushion. Carry it there!':
    'Kočka chce spát na červeném polštáři. Přenes ji tam!',
  'Select a part of the picture with a box, drag it somewhere else, then Place it.':
    'Vyber část obrázku obdélníkem, přetáhni ji jinam a pak ji Umísti.',
  'Tap the Select tool.':
    'Klepni na nástroj Výběr.',
  'Drag a box around the whole cat.':
    'Natáhni obdélník kolem celé kočky.',
  'Now drag the cat onto the cushion.':
    'Teď přetáhni kočku na polštář.',
  'Tap Place – the cat lies down.':
    'Klepni na Umístit – kočka si lehne.',
  'The fish turns round':
    'Rybka se otočí',
  'The fish wants to swim the other way – and a little upwards.':
    'Rybka chce plavat na druhou stranu – a trochu nahoru.',
  'A selection can be flipped, and turned with the round knob above it.':
    'Výběr se dá překlopit a otočit kulatým úchytem nad ním.',
  'Drag a box around the fish.':
    'Natáhni obdélník kolem rybky.',
  'Tap Flip horizontally – the fish looks the other way.':
    'Klepni na Překlopit vodorovně – rybka se dívá na druhou stranu.',
  'Drag the round knob above the fish a little to the side.':
    'Posuň kulatý úchyt nad rybkou trochu do strany.',
  'Tap Place.':
    'Klepni na Umístit.',
  'Two balloons':
    'Dva balonky',
  'One balloon is not enough. Cut it out along its edge and make a second one.':
    'Jeden balonek nestačí. Vystřihni ho podél okraje a udělej druhý.',
  'The Lasso selects any shape you draw around. Duplicate leaves a copy and gives you a new one to move.':
    'Laso vybere jakýkoli tvar, který obkreslíš. Duplikovat nechá kopii a dá ti novou k posunutí.',
  'Choose Lasso – it goes around any shape.':
    'Vyber Laso – obkreslí jakýkoli tvar.',
  'Draw a line all the way around the balloon.':
    'Obtáhni čáru úplně kolem balonku.',
  'Tap Duplicate.':
    'Klepni na Duplikovat.',
  'Drag the new balloon over to the empty sky.':
    'Přetáhni nový balonek na prázdnou oblohu.',
  'Change the blue sky into an orange sunset.':
    'Změň modrou oblohu na oranžový západ slunce.',
  'The Wand selects everything of one color with a single tap. Clear empties the selection.':
    'Hůlka jedním klepnutím vybere všechno jedné barvy. Vymazat výběr vyprázdní.',
  'Choose the Wand – it picks one color.':
    'Vyber Hůlku – vybere jednu barvu.',
  'Tap the blue sky.':
    'Klepni na modrou oblohu.',
  'Tap Clear – the sky disappears.':
    'Klepni na Vymazat – obloha zmizí.',
  'Now take the Paint bucket.':
    'Teď vezmi Kyblík.',
  'Tap the empty sky – a sunset!':
    'Klepni na prázdnou oblohu – západ slunce!',
  'Name poster':
    'Plakát se jménem',
  'Write your name on the green banner.':
    'Napiš své jméno na zelený pruh.',
  'The Text tool writes words in any size and font – with an outline, a shadow or bent in a curve.':
    'Text píše slova v jakékoli velikosti a písmu – s obrysem, stínem nebo do oblouku.',
  'Tap the Text tool.':
    'Klepni na nástroj Text.',
  'Tap in the middle of the green banner.':
    'Klepni doprostřed zeleného pruhu.',
  'Type your name.':
    'Napiš své jméno.',
  'Make the letters big: Size 60.':
    'Zvětši písmena: Velikost 60.',
  'Turn on Outline.':
    'Zapni Obrys.',
  'Tap Done.':
    'Klepni na Hotovo.',
  'Drag your name into the banner.':
    'Přetáhni své jméno do pruhu.',
  'Twin flowers':
    'Květinová dvojčata',
  'One pot is empty. Grow the same flower in it – copy it with Clone.':
    'Jeden květináč je prázdný. Vypěstuj v něm stejnou květinu – zkopíruj ji Klonováním.',
  'Clone paints with a copy of another part of the picture: first tap where to copy from, then paint.':
    'Klonování maluje kopií jiné části obrázku: nejdřív klepni, odkud kopírovat, pak maluj.',
  'Tap the Clone tool – the stamp.':
    'Klepni na Klonování – razítko.',
  'Make it big: Size 30 or more.':
    'Zvětši ho: Velikost 30 nebo víc.',
  'Tap the middle of the flower – the copy comes from there.':
    'Klepni doprostřed květiny – odtud se bude kopírovat.',
  'Start in the middle of the dashed circle, then paint all over it – a twin flower grows!':
    'Začni uprostřed čárkovaného kruhu a pak ho celý přemaluj – vyroste květinové dvojče!',
  'Fix the apple':
    'Oprav jablko',
  'The apple has 3 scratches. Heal them so it looks new.':
    'Jablko má 3 škrábance. Zahoj je, ať vypadá jako nové.',
  'Heal copies a clean part and blends it in, so spots and scratches disappear.':
    'Retuš zkopíruje čisté místo a splyne s okolím, takže skvrny a škrábance zmizí.',
  'Tap the Heal tool – the plaster.':
    'Klepni na Retuš – náplast.',
  'Tap a clean part of the apple.':
    'Klepni na čisté místo jablka.',
  'Paint over the 3 scratches.':
    'Přemaluj 3 škrábance.',
  'Clean beach':
    'Čistá pláž',
  'Someone left a can on the beach. Make it disappear!':
    'Někdo nechal na pláži plechovku. Nech ji zmizet!',
  'Remove fills what you paint over from the picture around it – things vanish.':
    'Odstranit vyplní, co přemaluješ, obrázkem z okolí – věci zmizí.',
  'Tap the Remove tool.':
    'Klepni na nástroj Odstranit.',
  'Paint over the whole can, then lift your finger.':
    'Přemaluj celou plechovku a pak zvedni prst.',
  'Star sticker':
    'Hvězdná samolepka',
  'The star looks stuck on. Soften its edge with Blur and give it grain with Noise.':
    'Hvězda vypadá jako nalepená. Změkči jí okraj Rozmazáním a dej jí zrno Šumem.',
  'Blur softens, Noise adds grain – together they blend a pasted picture into a photo.':
    'Rozmazání změkčuje, Šum přidává zrno – spolu napojí vložený obrázek do fotky.',
  'Tap the Blur tool – the drop.':
    'Klepni na Rozmazání – kapku.',
  'Make it stronger: slide Strength to 6 or more.':
    'Zesil ho: posuň Sílu na 6 nebo víc.',
  'Paint along the edge of the star.':
    'Maluj podél okraje hvězdy.',
  'Now tap the Noise tool – the dots.':
    'Teď klepni na Šum – tečky.',
  'Slide Amount to 30 or more.':
    'Posuň Množství na 30 nebo víc.',
  'Paint over the star – it gets grainy, like the photo.':
    'Přemaluj hvězdu – bude zrnitá jako fotka.',
  'Whirlpool':
    'Vír',
  'Stir up the lake – make a whirlpool in the circle.':
    'Rozvíř jezero – udělej v kruhu vír.',
  'Twist swirls the picture: press the middle, drag out for the size, go round to twist.':
    'Zkroucení zavíří obrázek: stiskni střed, táhni ven pro velikost a kružením kruť.',
  'Tap the Twist tool – the spiral.':
    'Klepni na Zkroucení – spirálu.',
  'Press in the middle of the circle, drag out to its edge, then go round and round.':
    'Stiskni uprostřed kruhu, táhni ven k jeho okraji a pak krouži dokola.',
  'Painting':
    'Malování',
  'Selecting and moving':
    'Výběr a přesouvání',
  'Photo magic':
    'Kouzla s fotkou',
  'Lessons':
    'Lekce',
  'Open the editor':
    'Otevřít editor',
  'Learn the tools':
    'Nauč se nástroje',
  'Small tasks, one tool at a time. A glowing frame shows what to tap next – just follow it.':
    'Malé úkoly, jeden nástroj po druhém. Zářící rámeček ukazuje, na co klepnout – stačí ho následovat.',
  '← All tasks':
    '← Všechny úkoly',
  '🔊 Read aloud':
    '🔊 Přečíst nahlas',
  '↺ Start again':
    '↺ Znovu',
  'Well done!':
    'Výborně!',
  'All tasks':
    'Všechny úkoly',
  'Lesson':
    'Lekce',
  'Back to all tasks':
    'Zpět na všechny úkoly',
  'Read the instruction aloud':
    'Přečíst pokyn nahlas',
  'Start this task again':
    'Začít tento úkol znovu',
  'Mosaic Paint Raster':
    'Mosaic Paint Raster',
  'Lessons: learn every tool step by step →':
    'Lekce: nauč se každý nástroj krok za krokem →',
  'Lessons (learn.html, linked from the raster app’s ? guide): 20 small tasks that teach every raster tool, one at a time. A glowing frame shows what to tap next – the tool, its setting, the part of the picture – and the next step comes by itself. The Curve tool now shows the Size slider.':
    'Lekce (learn.html, odkaz je v průvodci ? v rastrové aplikaci): 20 malých úkolů, které naučí každý rastrový nástroj, jeden po druhém. Zářící rámeček ukazuje, na co klepnout – nástroj, jeho nastavení, část obrázku – a další krok přijde sám. Nástroj Křivka teď ukazuje posuvník Velikost.',
};
